"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f115 = void 0;
exports.f115 = {
    "saharan": [
        21
    ],
    "spoken": [
        21,
        39,
        55,
        70,
        73,
        81,
        82,
        83,
        84,
        85,
        91,
        116,
        117,
        118,
        136,
        224,
        368,
        369,
        370,
        449,
        451,
        456,
        457,
        458,
        531,
        537,
        579,
        582,
        583,
        585,
        6855,
        6856,
        7136
    ],
    "saharan arabic": [
        21
    ],
    "states": [
        2497,
        2498,
        23,
        80,
        127,
        193,
        256,
        260,
        261,
        378,
        379,
        380,
        381,
        391,
        401,
        442,
        448,
        463,
        464,
        502,
        506,
        922,
        1008,
        1331,
        1408,
        1439,
        1443,
        1445,
        1446,
        1449,
        1450,
        1451,
        1455,
        1456,
        1460,
        1466,
        1467,
        1475,
        1476,
        1482,
        1509,
        1523,
        1534,
        1570,
        1571,
        1577,
        1581,
        1601,
        1603,
        1616,
        1618,
        1626,
        1638,
        1642,
        1649,
        1650,
        1655,
        1657,
        1666,
        1690,
        1731,
        1801,
        1806,
        2111,
        2112,
        2118,
        2146,
        2147,
        2152,
        2218,
        2283,
        2291,
        2296,
        2297,
        2298,
        2299,
        2305,
        2325,
        2396,
        2466,
        2567,
        2813,
        2882,
        2907,
        2939,
        3027,
        3032,
        3041,
        3085,
        3102,
        3177,
        3178,
        3207,
        3214,
        3226,
        3230,
        3562,
        3673,
        3679,
        3683,
        3719,
        3723,
        3764,
        3866,
        3871,
        3880,
        3928,
        3964,
        4003,
        4035,
        4139,
        4143,
        4371,
        4415,
        4418,
        4461,
        4477,
        4523,
        4536,
        4604,
        4706,
        4782,
        4791,
        4802,
        4820,
        4843,
        4855,
        4862,
        4952,
        4962,
        4978,
        5041,
        5043,
        5051,
        5142,
        5151,
        5238,
        5357,
        5414,
        5432,
        5528,
        5583,
        5584,
        5611,
        5628,
        5629,
        5677,
        5698,
        5709,
        5721,
        5748,
        5752,
        5756,
        5770,
        5826,
        5844,
        5904,
        5937,
        5969,
        5970,
        6032,
        6035,
        6039,
        6082,
        6090,
        6093,
        6097,
        6103,
        6108,
        6146,
        6147,
        6153,
        6211,
        6220,
        6257,
        6258,
        6259,
        6263,
        6310,
        6327,
        6371,
        6373,
        6377,
        6396,
        6402,
        6406,
        6435,
        6453,
        6660,
        6778,
        6791,
        6836,
        6854,
        6882,
        6909,
        6912,
        6915,
        6946,
        6951,
        7005,
        7059,
        7181,
        7301,
        7320,
        7356,
        7430,
        7431,
        7432,
        7438,
        7506,
        7517,
        7568,
        7569,
        7647,
        7656,
        7686,
        7693,
        7782,
        7795,
        7799,
        7818,
        7823,
        7949,
        7956,
        7974,
        8023,
        8073,
        8122,
        8148,
        8150,
        8160,
        8162,
        8167,
        8229,
        8239,
        8243,
        8260,
        8300,
        8308,
        8309,
        8382,
        8410,
        8431,
        8569,
        8603,
        8624,
        8636,
        8681,
        8691,
        8728,
        8735,
        8864,
        8876,
        8921,
        8927,
        8931,
        8933,
        8937,
        9041,
        9064,
        9177
    ],
    "solong": [
        27,
        2320,
        2321,
        2322
    ],
    "sambal": [
        6702,
        8628,
        34,
        46,
        588,
        938,
        6807,
        6971
    ],
    "saint francis": [
        36
    ],
    "saint": [
        2297,
        2298,
        36,
        65,
        200,
        2568,
        1599,
        2171,
        2173,
        2204,
        2219,
        2423,
        2445,
        2454,
        7217
    ],
    "sungai": [
        37,
        1981,
        7839,
        1117,
        1143,
        1902
    ],
    "shi’ite": [
        55
    ],
    "sama": [
        5484,
        6950,
        6966,
        6972,
        7129,
        7132,
        7133,
        1375,
        6238,
        6896,
        7280,
        57,
        696,
        702,
        5437,
        6074
    ],
    "sama abaknon": [
        57
    ],
    "saint lucian creole french": [
        65
    ],
    "saint lucia": [
        65,
        2173
    ],
    "shuli": [
        66
    ],
    "sare": [
        67,
        1884
    ],
    "syrian": [
        7268,
        70,
        307,
        308,
        309,
        310,
        368,
        430,
        437,
        2459,
        4320,
        5824,
        7920
    ],
    "sa’": [
        71
    ],
    "səgəmuk": [
        72
    ],
    "southern yemeni spoken arabic": [
        73
    ],
    "southern": [
        6946,
        7157,
        7257,
        174,
        275,
        276,
        303,
        569,
        575,
        764,
        765,
        854,
        924,
        1239,
        1298,
        1333,
        1334,
        1608,
        1609,
        1645,
        1646,
        1649,
        1813,
        2629,
        2771,
        2857,
        2908,
        2970,
        2991,
        2996,
        3000,
        3266,
        3699,
        3794,
        3795,
        3956,
        3972,
        4186,
        4485,
        4541,
        4812,
        4949,
        5123,
        5284,
        5331,
        5477,
        5614,
        5652,
        5666,
        5684,
        5827,
        5978,
        6057,
        6103,
        6210,
        6223,
        6407,
        6441,
        6445,
        6511,
        6694,
        6736,
        6753,
        6915,
        7003,
        7043,
        7121,
        7129,
        7156,
        7359,
        7517,
        7529,
        8044,
        8228,
        8840,
        8910,
        8940,
        9158,
        73,
        353,
        354,
        355,
        607,
        614,
        784,
        1117,
        1129,
        1184,
        1218,
        1339,
        1462,
        1463,
        1464,
        1960,
        2053,
        2250,
        2509,
        2566,
        2736,
        2737,
        2738,
        3034,
        3066,
        3275,
        3534,
        3598,
        3599,
        3713,
        3714,
        3715,
        3716,
        3717,
        3718,
        3741,
        3759,
        3939,
        4341,
        4342,
        4425,
        4572,
        4587,
        4588,
        4589,
        4735,
        4996,
        5255,
        5293,
        5294,
        5295,
        5296,
        5297,
        5317,
        5490,
        5550,
        5560,
        5648,
        5661,
        5662,
        5709,
        5896,
        6045,
        6056,
        6065,
        6066,
        6111,
        6251,
        6377,
        6427,
        6703,
        6837,
        6838,
        6839,
        6872,
        6889,
        6963,
        6995,
        6996,
        7042,
        7177,
        7412,
        7549,
        8023,
        8972,
        9139,
        9184,
        9186,
        9187,
        9188,
        618,
        619,
        4736,
        9044,
        9045,
        9047,
        9048
    ],
    "sa": [
        6685,
        7871,
        5695,
        6062,
        6063,
        6694,
        7274,
        2997,
        2998,
        5696,
        81,
        409,
        426,
        431,
        451,
        6756,
        8556
    ],
    "saudi arabia": [
        81,
        409,
        426,
        431,
        451,
        6756,
        8556
    ],
    "saudi": [
        6756,
        81,
        409,
        426,
        431,
        451,
        8556
    ],
    "sanna": [
        83,
        84,
        85
    ],
    "sd": [
        86,
        147,
        370,
        427,
        544,
        693,
        724,
        1089,
        1277,
        1291,
        1730,
        1793,
        1822,
        1823,
        1824,
        1854,
        1954,
        2095,
        2096,
        2201,
        2383,
        2384,
        2385,
        2490,
        2500,
        2632,
        2687,
        2871,
        2881,
        2913,
        3387,
        3434,
        3521,
        3523,
        3553,
        3560,
        3564,
        3632,
        3672,
        3751,
        4194,
        4343,
        4396,
        4444,
        4484,
        4687,
        4893,
        4973,
        5744,
        5795,
        5935,
        5990,
        6473,
        6840,
        6858,
        7033,
        7307,
        7327,
        7336,
        7345,
        7424,
        7434,
        7497,
        7501,
        7575,
        7606,
        7690,
        7913,
        8261,
        8331,
        8453,
        8547,
        8580,
        8647,
        8975,
        8976,
        8977,
        9095
    ],
    "sudan": [
        220,
        692,
        694,
        923,
        3518,
        3942,
        4434,
        5795,
        6111,
        8261,
        8580,
        8581,
        86,
        147,
        370,
        427,
        544,
        693,
        724,
        1089,
        1277,
        1291,
        1730,
        1793,
        1822,
        1823,
        1824,
        1854,
        1954,
        2095,
        2096,
        2201,
        2383,
        2384,
        2385,
        2490,
        2500,
        2632,
        2687,
        2871,
        2881,
        2913,
        3387,
        3434,
        3521,
        3523,
        3553,
        3560,
        3564,
        3632,
        3672,
        3751,
        4194,
        4343,
        4396,
        4444,
        4484,
        4687,
        4893,
        4973,
        5744,
        5935,
        5990,
        6473,
        6840,
        6858,
        7033,
        7307,
        7327,
        7336,
        7345,
        7424,
        7434,
        7497,
        7501,
        7575,
        7606,
        7690,
        7913,
        8331,
        8453,
        8547,
        8647,
        8975,
        8976,
        8977,
        9095,
        337,
        338,
        429,
        504,
        543,
        737,
        738,
        741,
        742,
        1018,
        1204,
        1249,
        1772,
        1846,
        1848,
        1856,
        1857,
        1859,
        1864,
        1890,
        2207,
        2351,
        2554,
        3030,
        3140,
        3491,
        3854,
        4369,
        4373,
        4446,
        4459,
        4460,
        4473,
        4526,
        4554,
        4735,
        4741,
        4742,
        4743,
        5029,
        5132,
        5140,
        5141,
        5195,
        5240,
        5384,
        5499,
        5743,
        5766,
        6841,
        6842,
        7433,
        7466,
        7485,
        7651,
        9109
    ],
    "sagu": [
        101
    ],
    "sign": [
        1969,
        6819,
        102,
        103,
        119,
        124,
        139,
        463,
        464,
        474,
        475,
        481,
        750,
        751,
        753,
        1006,
        1063,
        1207,
        1315,
        1402,
        1631,
        1632,
        1633,
        1634,
        1635,
        1641,
        1643,
        1647,
        1648,
        1653,
        1944,
        1972,
        2058,
        2071,
        2292,
        2294,
        2295,
        2306,
        2350,
        2476,
        2477,
        2478,
        2593,
        2787,
        2788,
        2790,
        2794,
        2820,
        2883,
        2887,
        2918,
        2963,
        3034,
        3041,
        3059,
        3060,
        3129,
        3185,
        3202,
        3219,
        3224,
        3249,
        3250,
        3257,
        3361,
        3385,
        3388,
        3414,
        3425,
        3439,
        3626,
        4055,
        4234,
        4390,
        4490,
        4493,
        4496,
        4498,
        4499,
        4500,
        4503,
        4504,
        4505,
        4556,
        4663,
        4728,
        5043,
        5076,
        5090,
        5259,
        5262,
        5280,
        5326,
        5352,
        5689,
        5692,
        5697,
        5699,
        5818,
        5881,
        6120,
        6177,
        6292,
        6305,
        6309,
        6310,
        6312,
        6315,
        6318,
        6319,
        6321,
        6387,
        6559,
        6602,
        6603,
        6604,
        6756,
        6799,
        6802,
        6811,
        6826,
        6944,
        6955,
        7077,
        7083,
        7087,
        7144,
        7146,
        7219,
        7239,
        7281,
        7291,
        7292,
        7733,
        7741,
        7743,
        7745,
        7751,
        7879,
        7923,
        7925,
        7937,
        7940,
        8077,
        8139,
        8140,
        8141,
        8190,
        8499,
        8541,
        8548,
        8787,
        8793,
        8906,
        8907,
        9052,
        9157,
        465,
        1074,
        3336
    ],
    "sa’idi": [
        118
    ],
    "saidi arabic": [
        118
    ],
    "saidi": [
        118
    ],
    "señas": [
        119,
        1631,
        1634,
        1635,
        1643,
        1648,
        2058,
        2294,
        2918,
        4500,
        4504,
        4728,
        5076,
        5352,
        6292,
        6387,
        7144,
        7925,
        8140
    ],
    "south africa": [
        132,
        133,
        134,
        1540,
        2224,
        2402,
        2406,
        2640,
        2673,
        3918,
        3924,
        4555,
        5427,
        5661,
        5662,
        5682,
        5695,
        5696,
        5940,
        6802,
        7127,
        7156,
        7613,
        7727,
        7728,
        8067,
        8068,
        8400,
        8452,
        8472,
        8473,
        8483,
        9172,
        9173
    ],
    "south": [
        6802,
        7067,
        224,
        558,
        599,
        600,
        601,
        825,
        1594,
        1846,
        2250,
        2340,
        3999,
        4398,
        4431,
        4649,
        4722,
        5021,
        5777,
        5917,
        6963,
        348,
        367,
        1026,
        1462,
        1463,
        1464,
        1907,
        2111,
        2112,
        2658,
        3063,
        3151,
        4211,
        4356,
        4485,
        4640,
        4792,
        5221,
        5661,
        5662,
        6085,
        6223,
        6441,
        6542,
        6685,
        6747,
        6857,
        7010,
        7084,
        7085,
        7114,
        7457,
        7957,
        8061,
        8364,
        8532,
        9135,
        220,
        692,
        694,
        923,
        1804,
        1805,
        3726,
        4434,
        4797,
        6394,
        6480,
        7620,
        132,
        133,
        134,
        337,
        338,
        429,
        504,
        543,
        737,
        738,
        741,
        742,
        1018,
        1204,
        1249,
        1540,
        1772,
        1848,
        1856,
        1857,
        1859,
        1864,
        1890,
        2207,
        2224,
        2351,
        2402,
        2406,
        2554,
        2640,
        2673,
        3030,
        3140,
        3491,
        3854,
        3918,
        3924,
        3942,
        4369,
        4373,
        4446,
        4459,
        4460,
        4473,
        4526,
        4554,
        4555,
        4735,
        4741,
        4742,
        4743,
        5029,
        5132,
        5140,
        5141,
        5195,
        5240,
        5384,
        5427,
        5499,
        5682,
        5695,
        5696,
        5743,
        5766,
        5940,
        6111,
        6841,
        6842,
        7127,
        7156,
        7433,
        7466,
        7485,
        7613,
        7651,
        7727,
        7728,
        8067,
        8068,
        8400,
        8452,
        8472,
        8473,
        8483,
        9109,
        9172,
        9173
    ],
    "seminole": [
        146,
        4802
    ],
    "santa crucino": [
        150
    ],
    "santa": [
        1569,
        3100,
        4673,
        5255,
        5467,
        6060,
        6446,
        9128,
        9133,
        9164,
        150,
        1626,
        3226,
        3697,
        6373,
        6424,
        6720,
        6721,
        7171,
        9119,
        605,
        4629,
        4800,
        4803,
        5224,
        5560,
        5720,
        6056,
        7431,
        8579,
        8654,
        8663,
        8973,
        8974,
        8992,
        9124,
        9138,
        9142,
        9161
    ],
    "senagi": [
        156
    ],
    "sinale": [
        162
    ],
    "simpi": [
        168
    ],
    "sinauna": [
        171
    ],
    "sinauna tagalog": [
        171
    ],
    "sb": [
        172,
        194,
        277,
        367,
        510,
        513,
        610,
        797,
        913,
        926,
        1097,
        1198,
        1199,
        1248,
        1945,
        2199,
        2334,
        2344,
        2617,
        2633,
        2689,
        2770,
        3017,
        3312,
        3706,
        3747,
        3960,
        4076,
        4078,
        4170,
        4298,
        4299,
        4305,
        4309,
        4311,
        4391,
        4546,
        4887,
        4894,
        4955,
        5001,
        5053,
        5105,
        5163,
        5417,
        5436,
        5515,
        5547,
        5560,
        5650,
        5720,
        5867,
        5950,
        6158,
        6161,
        6598,
        6602,
        6622,
        6692,
        6937,
        7171,
        7221,
        7291,
        7292,
        7332,
        7545,
        7553,
        7578,
        7635,
        7692,
        7804,
        7922,
        8025,
        8128,
        8137
    ],
    "solomon islands": [
        172,
        194,
        277,
        367,
        510,
        513,
        610,
        797,
        913,
        926,
        1097,
        1198,
        1199,
        1248,
        1945,
        2199,
        2334,
        2344,
        2617,
        2633,
        2689,
        2770,
        3017,
        3312,
        3706,
        3747,
        3960,
        4076,
        4078,
        4170,
        4298,
        4299,
        4305,
        4309,
        4311,
        4391,
        4546,
        4887,
        4894,
        4955,
        5001,
        5053,
        5105,
        5163,
        5417,
        5436,
        5515,
        5547,
        5560,
        5650,
        5720,
        5867,
        5950,
        6158,
        6161,
        6598,
        6602,
        6622,
        6692,
        6937,
        7171,
        7221,
        7291,
        7292,
        7332,
        7545,
        7553,
        7578,
        7635,
        7692,
        7804,
        7922,
        8025,
        8128,
        8137
    ],
    "solomon": [
        7291,
        7292,
        5105,
        8025,
        172,
        194,
        277,
        367,
        510,
        513,
        610,
        797,
        913,
        926,
        1097,
        1198,
        1199,
        1248,
        1945,
        2199,
        2334,
        2344,
        2617,
        2633,
        2689,
        2770,
        3017,
        3312,
        3706,
        3747,
        3960,
        4076,
        4078,
        4170,
        4298,
        4299,
        4305,
        4309,
        4311,
        4391,
        4546,
        4887,
        4894,
        4955,
        5001,
        5053,
        5163,
        5417,
        5436,
        5515,
        5547,
        5560,
        5650,
        5720,
        5867,
        5950,
        6158,
        6161,
        6598,
        6602,
        6622,
        6692,
        6937,
        7171,
        7221,
        7332,
        7545,
        7553,
        7578,
        7635,
        7692,
        7804,
        7922,
        8128,
        8137
    ],
    "shui": [
        7236,
        8835,
        173
    ],
    "southern alta": [
        174
    ],
    "san ramon inagta": [
        175
    ],
    "san": [
        6722,
        603,
        1687,
        3075,
        3091,
        3097,
        4096,
        4571,
        4593,
        4798,
        4819,
        6197,
        6251,
        6265,
        6277,
        6426,
        7716,
        8653,
        8658,
        9125,
        9139,
        9143,
        9163,
        3130,
        175,
        1355,
        1568,
        2575,
        2576,
        4824,
        4877,
        6046,
        6415,
        6505,
        6694,
        6915,
        7167,
        7274,
        7888,
        7889,
        7890,
        7891,
        8970,
        8986,
        9114,
        9132,
        9138,
        9169,
        9170,
        602,
        605,
        1330,
        1516,
        1548,
        1584,
        1676,
        3827,
        4581,
        4590,
        4792,
        4815,
        4817,
        5121,
        5124,
        5157,
        5223,
        5264,
        5991,
        5992,
        7432,
        7702,
        7718,
        8117,
        8118,
        8125,
        8652,
        8654,
        8656,
        8972,
        9003,
        9121,
        9122,
        9127,
        9129,
        9134,
        9135,
        9136,
        9141,
        9145,
        9160,
        9167,
        9168,
        3263
    ],
    "sdrato": [
        177
    ],
    "saint kitts creole english": [
        200
    ],
    "simaatn creole english": [
        200
    ],
    "simaatn": [
        200
    ],
    "sint maarten creole english": [
        200
    ],
    "sint": [
        200,
        2208,
        5543,
        8081,
        5539
    ],
    "swadaya": [
        203
    ],
    "sooreth": [
        203
    ],
    "suret": [
        203
    ],
    "sureth": [
        203,
        204,
        7277
    ],
    "suryaya swadaya": [
        203
    ],
    "suryaya": [
        203,
        7268
    ],
    "swadai": [
        203
    ],
    "sham doaniya": [
        210
    ],
    "sham": [
        210
    ],
    "ss": [
        220,
        337,
        338,
        429,
        504,
        543,
        692,
        694,
        737,
        738,
        741,
        742,
        923,
        1018,
        1204,
        1249,
        1772,
        1846,
        1848,
        1856,
        1857,
        1859,
        1864,
        1890,
        2207,
        2351,
        2554,
        3030,
        3140,
        3491,
        3854,
        3942,
        4369,
        4373,
        4434,
        4446,
        4459,
        4460,
        4473,
        4526,
        4554,
        4735,
        4741,
        4742,
        4743,
        5029,
        5132,
        5140,
        5141,
        5195,
        5240,
        5384,
        5499,
        5743,
        5766,
        6111,
        6841,
        6842,
        7433,
        7466,
        7485,
        7651,
        9109
    ],
    "south sudan": [
        220,
        337,
        338,
        429,
        504,
        543,
        692,
        694,
        737,
        738,
        741,
        742,
        923,
        1018,
        1204,
        1249,
        1772,
        1846,
        1848,
        1856,
        1857,
        1859,
        1864,
        1890,
        2207,
        2351,
        2554,
        3030,
        3140,
        3491,
        3854,
        3942,
        4369,
        4373,
        4434,
        4446,
        4459,
        4460,
        4473,
        4526,
        4554,
        4735,
        4741,
        4742,
        4743,
        5029,
        5132,
        5140,
        5141,
        5195,
        5240,
        5384,
        5499,
        5743,
        5766,
        6111,
        6841,
        6842,
        7433,
        7466,
        7485,
        7651,
        9109
    ],
    "south levantine arabic": [
        224
    ],
    "sr": [
        245,
        454,
        1878,
        1879,
        3013,
        3447,
        4094,
        5505,
        5542,
        7112,
        7113,
        7708,
        8173,
        9038
    ],
    "suriname": [
        3447,
        7113,
        245,
        454,
        1878,
        1879,
        3013,
        4094,
        5505,
        5542,
        7112,
        7708,
        8173,
        9038
    ],
    "siwu": [
        246
    ],
    "siwusi": [
        246
    ],
    "shopni": [
        269,
        270
    ],
    "shqip": [
        7068,
        7072,
        7074,
        269,
        270,
        7070,
        7071,
        7077
    ],
    "shqyp": [
        269,
        270
    ],
    "sapalewa": [
        272
    ],
    "southern altai": [
        275,
        276
    ],
    "sayaco": [
        287
    ],
    "sayacu": [
        287
    ],
    "sabari": [
        292
    ],
    "simi amdangtii": [
        294
    ],
    "simi": [
        6418,
        6427,
        294,
        5693,
        6393,
        6409,
        6430,
        6440,
        6441,
        6442
    ],
    "sawiyanu": [
        297
    ],
    "sawiyano": [
        297
    ],
    "southern amami-oshima": [
        303
    ],
    "southern amami-osima": [
        303
    ],
    "siryanooytha": [
        307,
        308,
        309,
        310
    ],
    "siryoon": [
        307,
        308,
        309,
        310
    ],
    "sy": [
        307,
        308,
        309,
        310,
        368,
        430,
        437,
        2459,
        4320,
        5824,
        7920
    ],
    "syrian arab republic": [
        307,
        308,
        309,
        310,
        368,
        430,
        437,
        2459,
        4320,
        5824,
        7920
    ],
    "spain": [
        314,
        478,
        1323,
        1327,
        1631,
        2256,
        2262,
        2268,
        2316,
        2324,
        2346,
        2674,
        2706,
        5213,
        5976,
        6408,
        6558,
        7144,
        8141,
        8389,
        8687
    ],
    "semigae": [
        316
    ],
    "shimigae": [
        316
    ],
    "simikai": [
        316
    ],
    "sanvi": [
        342
    ],
    "st": [
        344,
        1607,
        6286,
        6339
    ],
    "sao tome and principe": [
        344,
        1607,
        6286,
        6339
    ],
    "sao": [
        7134,
        7153,
        344,
        1607,
        6286,
        6339
    ],
    "south angal heneng": [
        348
    ],
    "south mendi": [
        348
    ],
    "southern arapesh": [
        353,
        354,
        355
    ],
    "sa’a": [
        367
    ],
    "saꞌa": [
        367
    ],
    "sa'a": [
        367
    ],
    "saa": [
        367,
        1725,
        5378,
        6685
    ],
    "south malaita": [
        367
    ],
    "syro-lebanese arabic": [
        368
    ],
    "syro-lebanese": [
        368
    ],
    "sudanese": [
        369,
        370,
        6111
    ],
    "sudanese arabic": [
        369,
        370
    ],
    "sanango ring": [
        376
    ],
    "sanango": [
        376
    ],
    "siasi": [
        386,
        6972
    ],
    "siassi": [
        386
    ],
    "safeyoka": [
        394
    ],
    "sanga": [
        6995,
        6996,
        8635,
        398,
        8638
    ],
    "standard": [
        1782,
        1785,
        1787,
        1791,
        1792,
        5070,
        9014,
        2393,
        4736,
        4738,
        6291,
        7017,
        7018,
        7022,
        7468,
        7469,
        9020,
        9021,
        9022,
        9030,
        9040,
        409,
        426,
        2302,
        2933,
        2934,
        2935,
        2936,
        3832,
        3833,
        3861,
        4542,
        5067,
        5068,
        7743,
        7987,
        7988,
        7991
    ],
    "sahara": [
        412
    ],
    "state of palestine": [
        424,
        3416,
        6668,
        6669,
        6670,
        6976,
        6977
    ],
    "state": [
        452,
        5991,
        455,
        2240,
        2241,
        3365,
        9001,
        424,
        3416,
        6668,
        6669,
        6670,
        6976,
        6977,
        3264,
        4185,
        5262
    ],
    "so": [
        7026,
        7147,
        7148,
        1194,
        1780,
        1988,
        1991,
        7428,
        7477,
        428,
        983,
        1762,
        2612,
        3369,
        7017,
        7018,
        7022,
        7689,
        8530,
        8849
    ],
    "somalia": [
        428,
        983,
        1762,
        2612,
        3369,
        7017,
        7018,
        7022,
        7689,
        8530,
        8849
    ],
    "sáhniš": [
        442
    ],
    "signes": [
        463,
        464,
        474,
        1006,
        1631,
        2350,
        2477,
        4490,
        6799,
        7146,
        8141,
        8548
    ],
    "sign america": [
        463,
        464
    ],
    "sabakor": [
        468
    ],
    "sebakoor": [
        468
    ],
    "sari": [
        469,
        5269,
        8748,
        8749
    ],
    "saari": [
        469
    ],
    "sali": [
        469
    ],
    "szi": [
        486,
        487
    ],
    "sabela": [
        512
    ],
    "sideme": [
        539
    ],
    "si-yà": [
        539
    ],
    "sia": [
        539
    ],
    "siya": [
        539
    ],
    "siyase": [
        539
    ],
    "siagha": [
        558,
        564
    ],
    "sjiagha": [
        558,
        564
    ],
    "south awyu": [
        558
    ],
    "syiagha": [
        558,
        564
    ],
    "sanghas": [
        568
    ],
    "southern aranda": [
        569
    ],
    "southern aymara": [
        575
    ],
    "sulaimitian arabic": [
        582
    ],
    "sulaimitian": [
        582
    ],
    "sanaani": [
        583
    ],
    "sanaani arabic": [
        583
    ],
    "samococio": [
        584
    ],
    "syro-mesopotamian arabic": [
        585
    ],
    "syro-mesopotamian": [
        585
    ],
    "syro-mesopotamian vernacular arabic": [
        585
    ],
    "sorsogon": [
        587,
        902,
        7121
    ],
    "sorsogon ayta": [
        587
    ],
    "shaoji phula": [
        598,
        8792,
        8819,
        8887
    ],
    "shaoji": [
        598,
        8792,
        8819,
        8887
    ],
    "sifter basket phula": [
        598,
        8792,
        8819,
        8887
    ],
    "sifter": [
        598,
        8792,
        8819,
        8887
    ],
    "south azerbaijani": [
        599,
        600,
        601
    ],
    "shikora": [
        602
    ],
    "san pedro amuzgos amuzgo": [
        603
    ],
    "southern atta": [
        607
    ],
    "sierra": [
        6826,
        1642,
        5698,
        5704,
        6915,
        8969,
        1528,
        1669,
        7653,
        608,
        1440,
        3834,
        4594,
        4692,
        4693,
        4796,
        5343,
        5556,
        5987,
        6255,
        6354,
        6399,
        6401,
        6419,
        949,
        1184,
        1194,
        2206,
        2363,
        2376,
        3828,
        3829,
        3934,
        4324,
        4449,
        7419
    ],
    "sierra aztec": [
        608
    ],
    "sierra puebla náhuatl": [
        608
    ],
    "sierra de zacapoaxtla nahuatl": [
        608
    ],
    "sunda": [
        7183,
        7184,
        7185,
        7186,
        612
    ],
    "southern yambassa": [
        614
    ],
    "sanaga": [
        615
    ],
    "shupamem": [
        630,
        631
    ],
    "shüpamom": [
        630,
        631
    ],
    "southwest bwa": [
        646
    ],
    "southwest": [
        2792,
        5765,
        6199,
        6313,
        646,
        4557,
        5476,
        8493
    ],
    "supapya": [
        656
    ],
    "supapyak’": [
        656
    ],
    "súpǎpyāˀ": [
        656
    ],
    "sn": [
        662,
        684,
        685,
        878,
        879,
        1059,
        1118,
        1332,
        1579,
        1640,
        1707,
        2038,
        2039,
        2343,
        2352,
        2364,
        2365,
        2458,
        2789,
        2931,
        3947,
        4888,
        4890,
        4891,
        5379,
        6682,
        6683,
        6994,
        7116,
        7117,
        7629,
        8302,
        8303
    ],
    "senegal": [
        662,
        684,
        685,
        878,
        879,
        1059,
        1118,
        1332,
        1579,
        1640,
        1707,
        2038,
        2039,
        2343,
        2352,
        2364,
        2365,
        2458,
        2789,
        2931,
        3947,
        4888,
        4890,
        4891,
        5379,
        6682,
        6683,
        6994,
        7116,
        7117,
        7629,
        8302,
        8303
    ],
    "southeast bwa": [
        674
    ],
    "southeast": [
        8592,
        3176,
        6314,
        7807,
        8065,
        674,
        5066,
        5361,
        5389,
        7622
    ],
    "samang": [
        680,
        8632
    ],
    "sengam": [
        680
    ],
    "shoo-minda-nye": [
        681
    ],
    "sibhēnde": [
        700
    ],
    "si’bende": [
        700
    ],
    "sodia parja": [
        706
    ],
    "sodia": [
        706
    ],
    "sauka": [
        719
    ],
    "saukas": [
        719,
        1397,
        1956,
        6508
    ],
    "shauka": [
        719
    ],
    "shaukas": [
        719,
        1397,
        1956,
        6508
    ],
    "shishong": [
        758
    ],
    "southern bai": [
        764,
        765
    ],
    "sbalt": [
        766,
        767,
        768
    ],
    "sbalti": [
        766,
        767,
        768
    ],
    "southern bangantu": [
        784
    ],
    "songnungbangle": [
        787
    ],
    "shʉ panəm": [
        787
    ],
    "shʉ": [
        787
    ],
    "sing": [
        6365,
        788
    ],
    "sisi-bipi": [
        850
    ],
    "southern birifor": [
        854
    ],
    "sud": [
        2775,
        874,
        1804,
        1805,
        3542,
        7359
    ],
    "sewan teteris": [
        895
    ],
    "sewan": [
        895
    ],
    "sorsoganon, northern": [
        902
    ],
    "sorsoganon": [
        902,
        7121
    ],
    "sorsogon bicolano": [
        902
    ],
    "sursugúnun": [
        902
    ],
    "siksika": [
        911,
        912
    ],
    "siksiká": [
        911,
        912
    ],
    "southern catanduanes bikol": [
        924
    ],
    "southern catanduanes bikolano": [
        924
    ],
    "sen chun": [
        928,
        929,
        930,
        931
    ],
    "sen": [
        928,
        929,
        930,
        931
    ],
    "sul": [
        936,
        5284
    ],
    "sl": [
        949,
        1184,
        1194,
        2206,
        2363,
        2376,
        3828,
        3829,
        3834,
        3934,
        4324,
        4449,
        4692,
        4693,
        6826,
        7419
    ],
    "sierra leone": [
        949,
        1184,
        1194,
        2206,
        2363,
        2376,
        3828,
        3829,
        3834,
        3934,
        4324,
        4449,
        4692,
        4693,
        6826,
        7419
    ],
    "sida min yao": [
        963
    ],
    "sida": [
        963,
        6956
    ],
    "somba-siawari": [
        964
    ],
    "sangasanga": [
        966
    ],
    "sanghasangha": [
        966
    ],
    "suri": [
        3854,
        7196,
        7197,
        981
    ],
    "skad": [
        997,
        1000,
        1001,
        3601,
        3602,
        4465,
        4466
    ],
    "sine": [
        1012
    ],
    "south ambrym": [
        1026
    ],
    "sasime": [
        1036
    ],
    "sarangani": [
        1042,
        4617
    ],
    "sarangani blaan": [
        1042
    ],
    "sorimi": [
        1046
    ],
    "suaseso": [
        1051
    ],
    "sese": [
        1083
    ],
    "sumbura": [
        1083
    ],
    "sotho": [
        5695,
        5696,
        7156,
        7157,
        1090
    ],
    "sakon": [
        1106
    ],
    "serbo-croatian": [
        6829,
        1114,
        1115,
        1552,
        1553,
        3042,
        3044,
        7088,
        7090,
        7092,
        7095,
        7096,
        7097,
        7098
    ],
    "southern bisaya": [
        1117
    ],
    "sii": [
        1119
    ],
    "shekhaniwar": [
        1122
    ],
    "sosi": [
        1123
    ],
    "swose": [
        1123
    ],
    "sur": [
        7396,
        1129,
        2242,
        4590,
        4796,
        4798,
        4812,
        5465,
        6383,
        6441,
        6889,
        7373,
        7639,
        7661,
        8663,
        9158
    ],
    "southern barasano": [
        1129
    ],
    "sitemu": [
        1131
    ],
    "sitemuú": [
        1131
    ],
    "stem baga": [
        1131
    ],
    "stem": [
        1131
    ],
    "sobané": [
        1139,
        1140
    ],
    "sobane": [
        1139,
        1140
    ],
    "sabah": [
        1143,
        5081,
        3115
    ],
    "sabah bisaya": [
        1143
    ],
    "shyen": [
        1150
    ],
    "sentah": [
        1151
    ],
    "siburan": [
        1151
    ],
    "simalungun": [
        1160,
        1161
    ],
    "sahap simalungun": [
        1160,
        1161
    ],
    "sahap": [
        1160,
        1161
    ],
    "simelungan": [
        1160,
        1161
    ],
    "sakalava": [
        6918,
        1172
    ],
    "shibushi": [
        1172
    ],
    "shongo": [
        1176
    ],
    "sherbro": [
        1184
    ],
    "shiba": [
        1184
    ],
    "southern bullom": [
        1184
    ],
    "southern bomitaba": [
        1218
    ],
    "southern bobo madaré": [
        1239
    ],
    "siasiada": [
        1255
    ],
    "samogho": [
        1269,
        1922,
        2016,
        3415,
        7042,
        7167
    ],
    "sprache von formosa": [
        1288,
        1303,
        3463,
        6279,
        8030
    ],
    "sprache": [
        1288,
        1303,
        3463,
        6279,
        8030,
        1501,
        6947
    ],
    "shongom": [
        1290
    ],
    "southern betsimisaraka malagasy": [
        1298
    ],
    "sorogama": [
        1300,
        1301
    ],
    "sarkanci": [
        1300,
        1301
    ],
    "sarkawa": [
        1300,
        1301
    ],
    "sorko": [
        1300,
        1301
    ],
    "sorogaama": [
        1300,
        1301
    ],
    "sorogoye": [
        1300,
        1301
    ],
    "sulawesi": [
        1308
    ],
    "sinais": [
        1315,
        7940
    ],
    "spsl": [
        1315
    ],
    "são paulo sign language": [
        1315
    ],
    "são": [
        9067,
        1315,
        1607
    ],
    "serer": [
        1332,
        2343,
        6994,
        7116,
        7117
    ],
    "southern carrier": [
        1333,
        1334
    ],
    "saipan carolinian": [
        1339
    ],
    "saipan": [
        1339
    ],
    "southern carolinian": [
        1339
    ],
    "san jorge": [
        1355
    ],
    "shimizya": [
        1355
    ],
    "simiza": [
        1355
    ],
    "sábέε": [
        1357
    ],
    "ṣabẹ": [
        1357
    ],
    "shawi": [
        1366
    ],
    "shahui": [
        1366
    ],
    "shayabit": [
        1366
    ],
    "shichopi": [
        1374
    ],
    "shicopi": [
        1374
    ],
    "shilenge": [
        1374
    ],
    "samba daka": [
        1375
    ],
    "samba": [
        1375,
        5366,
        6986,
        5138
    ],
    "swahili": [
        7223,
        7224,
        7225,
        7226,
        7227,
        7230,
        7231,
        7234,
        7235,
        1378,
        7228,
        7229
    ],
    "santiago": [
        6410,
        9137,
        5989,
        7881,
        7882,
        9162,
        1380,
        4686,
        4808,
        4996,
        5016,
        5991,
        8113,
        9120
    ],
    "sakma": [
        1381,
        1382,
        1384
    ],
    "sangma": [
        1381,
        1382,
        1384
    ],
    "sv": [
        1385,
        2282,
        2294,
        6271
    ],
    "salvador": [
        4096,
        1385,
        2282,
        2294,
        6271
    ],
    "sebuano": [
        1409,
        1410
    ],
    "sugbuanon": [
        1409,
        1410
    ],
    "sugbuhanon": [
        1409,
        1410
    ],
    "shomo karim": [
        1427
    ],
    "shomo": [
        1427
    ],
    "shomoh": [
        1427
    ],
    "shomong": [
        1427
    ],
    "shoalwater": [
        1443
    ],
    "suline": [
        1452,
        1453
    ],
    "súline": [
        1452,
        1453
    ],
    "seeptsa": [
        1457
    ],
    "sureste": [
        1461,
        1548,
        1660,
        5157,
        5229,
        5645,
        7173,
        7373,
        8126,
        9123,
        9171
    ],
    "south buton": [
        1462,
        1463,
        1464
    ],
    "southern butung": [
        1462,
        1463,
        1464
    ],
    "shipi": [
        1469
    ],
    "southwestern ojibwa": [
        1475,
        1476
    ],
    "southwestern": [
        8610,
        2347,
        2978,
        2979,
        4686,
        5705,
        7560,
        7833,
        8066,
        1856,
        1475,
        1476,
        2655,
        3315,
        3723,
        5356,
        6057,
        7412,
        1857,
        5875
    ],
    "sayma": [
        1477
    ],
    "seyu": [
        1481
    ],
    "shioko": [
        1484
    ],
    "shor": [
        1491,
        1492
    ],
    "shortsy": [
        1491,
        1492
    ],
    "sine’i": [
        1496,
        1497,
        1498
    ],
    "sorani": [
        1496,
        1497,
        1498
    ],
    "sak": [
        1499,
        8804
    ],
    "st-louis": [
        1507
    ],
    "shekwan": [
        1510
    ],
    "s’klallam": [
        1523
    ],
    "sierra oriental chatino": [
        1528
    ],
    "stotpa": [
        1541
    ],
    "sho": [
        1542,
        1636,
        1637,
        7076,
        6380
    ],
    "shenwa": [
        1556
    ],
    "shong": [
        1566
    ],
    "san francesco saverio mission": [
        1568
    ],
    "saverio": [
        1568
    ],
    "san francisco xavier de": [
        1568
    ],
    "san javier": [
        1568
    ],
    "san xavier": [
        1568
    ],
    "santa teresa cora": [
        1569
    ],
    "salish": [
        7175,
        2396,
        1570,
        4536,
        6946,
        7479,
        7480
    ],
    "sanjiang miao": [
        1580
    ],
    "sanjiang": [
        1580
    ],
    "south ucayali ashéninka": [
        1594
    ],
    "sichuan-guizhou-yunnan miao": [
        1595
    ],
    "sichuan-guizhou-yunnan": [
        1595
    ],
    "saint vincent and the grenadines": [
        1599,
        2219,
        7217
    ],
    "schitsu’umsh": [
        1601
    ],
    "skitswish": [
        1601
    ],
    "snchitsu’umshtsn": [
        1601
    ],
    "sãotomense": [
        1607
    ],
    "santome": [
        1607
    ],
    "santomense": [
        1607
    ],
    "santomé": [
        1607
    ],
    "são tomense": [
        1607
    ],
    "sud-est": [
        7456,
        1608,
        1609
    ],
    "southern east cree": [
        1608,
        1609
    ],
    "shore": [
        1614,
        1652
    ],
    "seychelles french creole": [
        1619
    ],
    "seychelles": [
        1619,
        2200,
        2457
    ],
    "seselwa": [
        1619
    ],
    "seselwa creole french": [
        1619
    ],
    "seselwa french creole": [
        1619
    ],
    "seychellois creole": [
        1619
    ],
    "seychellois": [
        1619
    ],
    "sc": [
        1619,
        2200,
        2457
    ],
    "santa rosa": [
        1626,
        3226,
        6373
    ],
    "signos": [
        1631,
        1635,
        4728,
        5352,
        6292,
        7144,
        8141
    ],
    "saingbaung": [
        1636,
        1637
    ],
    "shoa": [
        1636,
        1637,
        6855,
        6856
    ],
    "songlai": [
        1639
    ],
    "songlai chin": [
        1639
    ],
    "shouyu": [
        1641,
        7745
    ],
    "sochiapam": [
        1644
    ],
    "sochiapam chinantec": [
        1644
    ],
    "sochiapan chinantec": [
        1644
    ],
    "sochiapan": [
        1644
    ],
    "southern guangxi": [
        1645,
        1646
    ],
    "southern ping chinese": [
        1645,
        1646
    ],
    "southern pinghua": [
        1645,
        1646
    ],
    "southern ohlone": [
        1649
    ],
    "sumtu": [
        1651
    ],
    "settu": [
        1651
    ],
    "settu hmyo": [
        1651
    ],
    "sumtu chin": [
        1651
    ],
    "sungtu": [
        1651
    ],
    "swampy": [
        1652
    ],
    "swampy cree": [
        1652
    ],
    "siyin": [
        1654
    ],
    "siyang": [
        1654
    ],
    "siyin chin": [
        1654
    ],
    "sizang": [
        1654
    ],
    "sierra occidental chatino": [
        1669
    ],
    "slavonic, church": [
        1677,
        1678,
        1679
    ],
    "slavonic": [
        1677,
        1678,
        1679
    ],
    "slavic": [
        1677,
        1678,
        1679,
        4845,
        4846,
        6550,
        6551,
        7220
    ],
    "suka": [
        1684
    ],
    "san blas cuna": [
        1687
    ],
    "san blas kuna": [
        1687
    ],
    "siwang": [
        1706
    ],
    "sioux": [
        1731,
        4371
    ],
    "sanye": [
        1732,
        7142
    ],
    "sila": [
        6956,
        1742
    ],
    "shila": [
        1742
    ],
    "sula": [
        7289,
        1742,
        5012
    ],
    "sailen": [
        1758
    ],
    "songhay": [
        2971,
        3659,
        6792,
        1777
    ],
    "schweizer hochdeutsch": [
        1786
    ],
    "schweizer": [
        1786
    ],
    "switzerland": [
        1786,
        2137,
        2429,
        2795,
        3262,
        6331,
        6539,
        6556,
        6811,
        6944,
        7146,
        8152
    ],
    "stockbridge-munsee": [
        1802
    ],
    "slave (athapascan)": [
        1804,
        1805
    ],
    "slave": [
        1804,
        1805
    ],
    "slavey, south": [
        1804,
        1805
    ],
    "slavey": [
        6734,
        6735,
        1804,
        1805
    ],
    "southern dagaare": [
        1813
    ],
    "southern dagari": [
        1813
    ],
    "simba": [
        6714,
        2721,
        1836
    ],
    "segeju": [
        6780,
        1840
    ],
    "sengeju": [
        1840,
        6780
    ],
    "south central dinka": [
        1846
    ],
    "satro": [
        1847
    ],
    "shitako": [
        1858
    ],
    "shimbogedu": [
        1863
    ],
    "saaronge": [
        1870
    ],
    "sanni": [
        1872,
        1873,
        1874
    ],
    "southeastern": [
        1890,
        5229,
        5485,
        5645,
        6257,
        7173,
        7373,
        9123,
        4639,
        4686,
        5997,
        6384,
        8909,
        9130,
        9133
    ],
    "southeastern dinka": [
        1890
    ],
    "sungai milian": [
        1902
    ],
    "south damar": [
        1907
    ],
    "sowari": [
        1913
    ],
    "samogo": [
        1922,
        2016
    ],
    "samoro": [
        1922,
        2016
    ],
    "southern baagandji": [
        1960
    ],
    "sarisen": [
        1966
    ],
    "sorbian, lower": [
        1968
    ],
    "sorbian": [
        1968,
        3058
    ],
    "sorabe": [
        1968,
        3058
    ],
    "sign language of the netherlands": [
        1969
    ],
    "sln": [
        1969
    ],
    "sogilitan": [
        1981
    ],
    "sungai kinabatangan": [
        1981
    ],
    "suang lotud": [
        1990
    ],
    "suang": [
        1990
    ],
    "sawa": [
        1995,
        5044
    ],
    "sotmali": [
        2012
    ],
    "sago": [
        2022,
        7449
    ],
    "speedwords": [
        2026
    ],
    "sénoufo, djimini": [
        2035
    ],
    "sénoufo": [
        2035,
        5241,
        6196,
        6775,
        6779,
        6787,
        6789,
        6790,
        6795,
        6863,
        7060,
        7464
    ],
    "senoufo": [
        2035,
        5241,
        6196,
        6775,
        6779,
        6795,
        6863,
        7060,
        7464
    ],
    "southern bontoc": [
        2053,
        5827
    ],
    "shuwa": [
        7279,
        2071,
        3385,
        3425,
        6855,
        6856
    ],
    "samap": [
        2094,
        3501
    ],
    "sangau": [
        2103
    ],
    "sanggau": [
        6723,
        2103
    ],
    "sambú": [
        2109
    ],
    "shimian minyag": [
        2110
    ],
    "shimian": [
        2110
    ],
    "shimian munya": [
        2110
    ],
    "shimian muya": [
        2110
    ],
    "south alaska eskimo": [
        2111,
        2112
    ],
    "sugcestun": [
        2111,
        2112
    ],
    "sugpiak eskimo": [
        2111,
        2112
    ],
    "sugpiak": [
        2111,
        2112
    ],
    "sugpiaq": [
        2111,
        2112
    ],
    "sugpiaq eskimo": [
        2111,
        2112
    ],
    "suk": [
        2111,
        2112,
        6174
    ],
    "samoa": [
        6962,
        2223,
        2124
    ],
    "saint kitts and nevis": [
        2171
    ],
    "se": [
        2202,
        2391,
        5631,
        6004,
        6561,
        6773,
        6892,
        6908,
        6963,
        6970,
        7209,
        7211,
        7239
    ],
    "sweden": [
        2202,
        2391,
        5631,
        6004,
        6561,
        6773,
        6892,
        6908,
        6963,
        6970,
        7209,
        7211,
        7239
    ],
    "sg": [
        2203,
        4605,
        5073,
        6955,
        7300,
        9037
    ],
    "singapore": [
        6955,
        2203,
        4605,
        5073,
        7300,
        9037
    ],
    "sh": [
        2204
    ],
    "saint helena, ascension and tristan da cunha": [
        2204
    ],
    "si": [
        4315,
        2205,
        6939,
        6940
    ],
    "slovenia": [
        2205,
        6939,
        6940
    ],
    "sx": [
        2208,
        5543,
        8081
    ],
    "sint maarten (dutch part)": [
        2208,
        5543,
        8081
    ],
    "sz": [
        2209,
        7128
    ],
    "swaziland": [
        2209,
        7128
    ],
    "samoyedic": [
        2231,
        2232
    ],
    "somatu": [
        2232
    ],
    "sie": [
        2247
    ],
    "sye": [
        2247
    ],
    "south efate": [
        2250
    ],
    "southern efate": [
        2250
    ],
    "stau": [
        2251
    ],
    "spanish": [
        2256,
        2257,
        2258,
        2259,
        2260,
        2261,
        2262,
        2263,
        2264,
        2265,
        2266,
        2267,
        2268,
        2269,
        2270,
        2271,
        2272,
        2273,
        2274,
        2275,
        2276,
        2277,
        2278,
        2279,
        2280,
        2281,
        2282,
        2283,
        2284,
        2285,
        7061,
        7144,
        5976,
        4189,
        4190,
        4191
    ],
    "salvadoran sign language": [
        2294
    ],
    "salvadoran": [
        2294
    ],
    "salvadoreñas": [
        2294
    ],
    "strait": [
        7371,
        2297,
        2298,
        5188
    ],
    "siberian": [
        7182,
        2297,
        2298,
        8862
    ],
    "saint lawrence island eskimo": [
        2297,
        2298
    ],
    "siberian yupik": [
        2297,
        2298
    ],
    "sivuqaghmiistun": [
        2297,
        2298
    ],
    "semimi": [
        2315
    ],
    "solon": [
        2320,
        2321,
        2322
    ],
    "sulong": [
        2320,
        2321,
        2322
    ],
    "suolun": [
        2320,
        2321,
        2322
    ],
    "south fali": [
        2340
    ],
    "siili": [
        2343
    ],
    "siili-mantine": [
        2343
    ],
    "siili-siili": [
        2343
    ],
    "sehudate": [
        2345
    ],
    "southwestern fars": [
        2347
    ],
    "signe": [
        2350
    ],
    "suomi": [
        2381,
        2382
    ],
    "sukot": [
        2383,
        2384,
        2385
    ],
    "standard fijian": [
        2393
    ],
    "sepantsula": [
        2402
    ],
    "setsotsi": [
        2402
    ],
    "shalambombo": [
        2402
    ],
    "sjita": [
        2402
    ],
    "silunguboi": [
        2406
    ],
    "siraya": [
        2415
    ],
    "sideia": [
        2415
    ],
    "sideis": [
        2415
    ],
    "sideisch": [
        2415
    ],
    "sinccan": [
        2415
    ],
    "sinckan": [
        2415
    ],
    "siraia": [
        2415
    ],
    "siraiya": [
        2415
    ],
    "sirayaic": [
        2415
    ],
    "saint barthélemy": [
        2423
    ],
    "suisse": [
        2429,
        7146
    ],
    "saint martin (french part)": [
        2445
    ],
    "saint pierre and miquelon": [
        2454
    ],
    "sera-larat-fordata": [
        2467
    ],
    "saxon, east frisian low": [
        2474
    ],
    "saxon": [
        2474,
        5375,
        7264,
        5979,
        4217,
        5376
    ],
    "svk": [
        2476
    ],
    "suomalainen viittomakieli": [
        2476
    ],
    "suomalainen": [
        2476
    ],
    "srvk": [
        2478
    ],
    "suomenruotsalainen viittomakieli": [
        2478
    ],
    "suomenruotsalainen": [
        2478
    ],
    "sanyo": [
        2479,
        2480
    ],
    "southern gabri": [
        2509
    ],
    "sumwari": [
        2543
    ],
    "southern tangkic": [
        2566
    ],
    "saint barthélemy french creole": [
        2568
    ],
    "scottish gaelic": [
        2573
    ],
    "scottish": [
        2573,
        7710
    ],
    "scots gaelic": [
        2573
    ],
    "scots": [
        6731,
        2573
    ],
    "san gadaba": [
        2575,
        2576
    ],
    "sano": [
        2575,
        2576
    ],
    "sek": [
        2578,
        6913,
        8804
    ],
    "siar": [
        2578,
        6905
    ],
    "siar-ragetta": [
        2578
    ],
    "szeak-bagili": [
        2578
    ],
    "shede": [
        2579
    ],
    "seram": [
        2609
    ],
    "seran": [
        2609
    ],
    "seran laut": [
        2609
    ],
    "sodua": [
        2625
    ],
    "southern ghale": [
        2629
    ],
    "shilha": [
        2634,
        3330,
        6837,
        6838,
        6839,
        6906,
        6519,
        6520,
        6521,
        6522,
        7884,
        7885,
        7886
    ],
    "sindhi ghera": [
        2635
    ],
    "sindhi": [
        6704,
        6741,
        6742,
        6743,
        6744,
        6745,
        6746,
        2635
    ],
    "southwestern gelao": [
        2655
    ],
    "south giziga": [
        2658
    ],
    "sushen": [
        2677
    ],
    "sara goula": [
        2685
    ],
    "sara": [
        6717,
        4079,
        4093,
        7105,
        2685,
        3969,
        5185,
        5233,
        6691,
        6920,
        7589
    ],
    "sara gula": [
        2685
    ],
    "simba guaraní": [
        2721
    ],
    "southern kanara": [
        2736,
        2737,
        2738
    ],
    "sughu": [
        2770
    ],
    "sugu": [
        2770,
        5632
    ],
    "southern grebo": [
        2771
    ],
    "sud oranais-gourara": [
        2775
    ],
    "sud-ouest": [
        2792
    ],
    "southwest gbaya": [
        2792
    ],
    "swiss": [
        2795,
        2796,
        2797
    ],
    "schwiizertüütsch": [
        2795,
        2796,
        2797
    ],
    "schweizerdeutsch": [
        2795
    ],
    "schwiizerdütsch": [
        2795
    ],
    "schwizerdütsch": [
        2795
    ],
    "schwizertitsch": [
        2795
    ],
    "schwizertitsch mundart": [
        2795
    ],
    "schwytzertuetsch": [
        2795,
        2797
    ],
    "schwyzerdütsch": [
        2795,
        2797
    ],
    "schwyzerdütschi sprooch": [
        2795
    ],
    "schwyzerdütschi": [
        2795
    ],
    "sprooch": [
        2795
    ],
    "swiss german": [
        2795,
        2796,
        2797
    ],
    "shiki": [
        2803
    ],
    "sikwani": [
        2809
    ],
    "sa-gumuz": [
        2811
    ],
    "sea island english creole": [
        2813
    ],
    "sea": [
        2813,
        3115
    ],
    "sea island creole english": [
        2813
    ],
    "shaathari": [
        2822
    ],
    "shamatari": [
        2822
    ],
    "shamatri": [
        2822
    ],
    "seto-gbe": [
        2823
    ],
    "satre": [
        2853
    ],
    "salang": [
        2896,
        6719,
        6919
    ],
    "sisimin": [
        2897
    ],
    "soba": [
        2900
    ],
    "southern haida": [
        2908
    ],
    "sabu": [
        2915,
        3099
    ],
    "semau": [
        2924
    ],
    "seit-kaitetu": [
        2947
    ],
    "sesarwa": [
        2950,
        6835
    ],
    "sherewyana": [
        2954
    ],
    "sokaka": [
        2954
    ],
    "sau": [
        6666,
        6752,
        7134,
        7152,
        2963
    ],
    "sansu": [
        2967
    ],
    "shansu": [
        2967
    ],
    "southern mashan hmong": [
        2970
    ],
    "southern mashan miao": [
        2970
    ],
    "songhay, humburi senni": [
        2971
    ],
    "senni": [
        2971,
        6792,
        7832
    ],
    "songai": [
        3659,
        6792,
        2971
    ],
    "songay": [
        2971,
        6792
    ],
    "songay senni": [
        2971,
        6792
    ],
    "songhai": [
        2971,
        3659,
        6792
    ],
    "songhoy": [
        2971,
        3659
    ],
    "songoi": [
        2971,
        3659,
        6792
    ],
    "songoy": [
        2971,
        3659,
        6792
    ],
    "sonrai": [
        2971,
        3659,
        6792
    ],
    "sonrhai": [
        2971,
        3659,
        6792
    ],
    "southwestern guiyang hmong": [
        2978
    ],
    "southwestern huishui hmong": [
        2979
    ],
    "southwestern huishui miao": [
        2979
    ],
    "southern east-guizhou miao": [
        2991
    ],
    "southern hmu": [
        2991
    ],
    "southern qiandong miao": [
        2991
    ],
    "southern guiyang hmong": [
        2996
    ],
    "southern guiyang miao": [
        2996
    ],
    "sinicized miao": [
        2997,
        2998
    ],
    "sinicized": [
        2997,
        2998
    ],
    "shua": [
        6835,
        6855,
        6856,
        2997,
        2998,
        3050
    ],
    "sua": [
        5094,
        6936,
        2997,
        2998
    ],
    "shuat": [
        2997,
        2998
    ],
    "shuixi miao": [
        2997,
        2998
    ],
    "shuixi": [
        2997,
        2998
    ],
    "sinicised hmong": [
        2997,
        2998
    ],
    "sinicised": [
        2997,
        2998
    ],
    "southern hindko": [
        3000
    ],
    "sarnami": [
        3013
    ],
    "sarnaanie hiendoestaanie": [
        3013
    ],
    "sarnaanie": [
        3013
    ],
    "sarnami hindi": [
        3013
    ],
    "sarnami hindoestani": [
        3013
    ],
    "southern vietnamese sign language": [
        3034
    ],
    "samong": [
        3040
    ],
    "sou": [
        7081,
        7580,
        8224,
        7581,
        3050
    ],
    "sorbian, upper": [
        3058
    ],
    "south arabian": [
        3063,
        6857,
        7084,
        7085
    ],
    "southern witoto": [
        3066
    ],
    "san francisco del mar huave": [
        3075
    ],
    "sanya hui": [
        3086
    ],
    "sanya": [
        3086,
        7142
    ],
    "san mateo del mar huave": [
        3091
    ],
    "san dionisio del mar huave": [
        3097
    ],
    "savu": [
        3099
    ],
    "savunese": [
        3099
    ],
    "sawu": [
        3099
    ],
    "sawunese": [
        3099
    ],
    "santa maría del mar huave": [
        3100
    ],
    "somekhuri": [
        3104,
        3105
    ],
    "somkhuri": [
        3104,
        3105
    ],
    "sepik": [
        3293,
        3565,
        3112,
        4622
    ],
    "sea dayak": [
        3115
    ],
    "san andrés creole": [
        3130
    ],
    "south central teke": [
        3151
    ],
    "sichuan yi": [
        3169,
        3170
    ],
    "sichuan": [
        3169,
        3170
    ],
    "southeast ijo": [
        3176
    ],
    "seward peninsula inupiaq": [
        3177
    ],
    "seward": [
        3177
    ],
    "shukulumbwe": [
        3193
    ],
    "sukulumbwe": [
        3193
    ],
    "samala": [
        3226
    ],
    "santa inez": [
        3226
    ],
    "segni": [
        3249,
        6944
    ],
    "sm": [
        3263
    ],
    "san marino": [
        3263
    ],
    "see": [
        3264,
        4185,
        5262
    ],
    "southern tidung": [
        3266
    ],
    "saramo": [
        3272,
        8979
    ],
    "sihnipadara": [
        3272
    ],
    "selemo": [
        3274
    ],
    "shekiri": [
        3274
    ],
    "southern itneg": [
        3275
    ],
    "sepik iwam": [
        3293
    ],
    "southwestern caribbean english creole": [
        3315
    ],
    "sohur": [
        3318
    ],
    "sebyar": [
        3327
    ],
    "sumuri": [
        3327
    ],
    "sain": [
        3336,
        7390,
        7391,
        7599
    ],
    "shiwilu": [
        3344
    ],
    "shiwilu la’la’": [
        3344
    ],
    "skofro": [
        3353
    ],
    "sẅíŋɛ́-mbɔ́ndaa": [
        3359
    ],
    "stodsde": [
        3368
    ],
    "shangzhai": [
        3368
    ],
    "shuar": [
        3376
    ],
    "shuar chicham": [
        3376
    ],
    "shuara": [
        3376
    ],
    "siurra": [
        3376
    ],
    "siwora": [
        3376
    ],
    "saturi": [
        3378
    ],
    "sijali": [
        3394
    ],
    "singja": [
        3394
    ],
    "sinjali": [
        3394
    ],
    "savi": [
        6752,
        4796,
        4799,
        4803,
        4804,
        8655,
        8656,
        3399,
        4572,
        4624,
        4629,
        4816,
        5121,
        5157,
        5226,
        8113,
        8118,
        8652,
        8654,
        8658,
        8664,
        8667
    ],
    "skadd": [
        3400,
        3601,
        3602,
        6737,
        7139
    ],
    "surinaams javaans": [
        3447
    ],
    "surinaams": [
        3447,
        7113
    ],
    "sibundoy": [
        3484
    ],
    "sibundoy-gaché": [
        3484
    ],
    "sobei": [
        7025,
        3485
    ],
    "sumup": [
        3501
    ],
    "sekalaka": [
        3516
    ],
    "sekalaña": [
        3516
    ],
    "shona": [
        6989,
        6990,
        3516,
        5361
    ],
    "soudan": [
        3518
    ],
    "southern luritja": [
        3534
    ],
    "shimakonde": [
        3535
    ],
    "simakonde": [
        3535
    ],
    "símákòòndè": [
        3535
    ],
    "seba": [
        3537
    ],
    "sewa": [
        6796,
        3537
    ],
    "shishi": [
        3537
    ],
    "souei": [
        3550,
        3551,
        3552
    ],
    "soai": [
        3550,
        3551,
        3552
    ],
    "soay": [
        3550,
        3551,
        3552
    ],
    "soei": [
        3550,
        3551,
        3552
    ],
    "souai": [
        3550,
        3551,
        3552
    ],
    "suai": [
        3550,
        3551,
        3552
    ],
    "suay": [
        3550,
        3551,
        3552
    ],
    "suei": [
        3550,
        3551,
        3552
    ],
    "sui": [
        7236,
        3550,
        3551,
        3552
    ],
    "suoi": [
        3550,
        3551,
        3552
    ],
    "sani ma-yɛgaŋ": [
        3560
    ],
    "sani": [
        8908,
        3560,
        6969
    ],
    "sepik plains": [
        3565
    ],
    "saumlaki": [
        3566
    ],
    "southern nonstandard kannada": [
        3598,
        3599
    ],
    "singli": [
        3607
    ],
    "selangor sign language": [
        3626
    ],
    "selangor": [
        3626
    ],
    "ssl": [
        3626,
        7239
    ],
    "somyev": [
        3637
    ],
    "somyewe": [
        3637
    ],
    "shu-ai-i": [
        3645,
        3646
    ],
    "shui-pai-i": [
        3645,
        3646
    ],
    "sipsongpanna dai": [
        3645,
        3646
    ],
    "sipsongpanna": [
        3645,
        3646
    ],
    "sakan": [
        3656,
        3657
    ],
    "songhay, koyra chiini": [
        3659
    ],
    "shan": [
        6845,
        6846,
        6847,
        6848,
        6486,
        7275,
        7524,
        3663,
        3743,
        7386,
        7387
    ],
    "sam": [
        7014,
        6471,
        6845,
        6846,
        6847,
        6848,
        3663
    ],
    "sayan samoyed": [
        3682
    ],
    "sayan": [
        3682
    ],
    "samoyed": [
        3682,
        5481,
        6786,
        8895
    ],
    "sheshi": [
        3684
    ],
    "sheshi kham": [
        3684
    ],
    "shar ma": [
        3688
    ],
    "shar": [
        3688
    ],
    "so-bê": [
        3688
    ],
    "santa eulalia kanjobal": [
        3697
    ],
    "southern kiwai": [
        3699
    ],
    "sonar boli": [
        3712
    ],
    "sonar": [
        3712
    ],
    "southern pwo karen": [
        3713,
        3714,
        3715,
        3716,
        3717,
        3718
    ],
    "southwestern pomo": [
        3723
    ],
    "south kewa": [
        3726
    ],
    "sharpa-lo": [
        3741
    ],
    "southern monpa": [
        3741
    ],
    "sagara": [
        6703,
        3744
    ],
    "solwa": [
        3744
    ],
    "southern teke": [
        3759
    ],
    "seruyan": [
        3760
    ],
    "sābāwōōt": [
        3777
    ],
    "sabaot": [
        3777
    ],
    "sebei": [
        3777,
        3897
    ],
    "southern dong": [
        3794,
        3795
    ],
    "san miguel acatán kanjobal": [
        3827
    ],
    "salakau": [
        3844
    ],
    "salako": [
        3844
    ],
    "selakau": [
        3844
    ],
    "selako": [
        3844
    ],
    "silakau": [
        3844
    ],
    "sàmòmá": [
        3846
    ],
    "sàmó": [
        3846
    ],
    "suri, kacipo-bale": [
        3854
    ],
    "sabiny": [
        3897
    ],
    "sapei": [
        3897
    ],
    "sanjaq": [
        3901
    ],
    "surat": [
        3901
    ],
    "soorit": [
        3901
    ],
    "sooret": [
        3901
    ],
    "seroa": [
        3918
    ],
    "sirata": [
        3925,
        3926
    ],
    "sulud": [
        3935
    ],
    "severno-karel’skij": [
        3937,
        3938
    ],
    "sobstvenno-karel’skij-jazyk": [
        3937,
        3938
    ],
    "sapo": [
        3939
    ],
    "sarpo": [
        3939
    ],
    "southern krahn": [
        3939
    ],
    "sota": [
        3949
    ],
    "sota kanum": [
        3949
    ],
    "shuwa-zamani": [
        3954
    ],
    "shambala": [
        3955
    ],
    "sambaa": [
        3955
    ],
    "sambala": [
        3955
    ],
    "sambara": [
        3955
    ],
    "schambala": [
        3955
    ],
    "shambaa": [
        3955
    ],
    "southern kalinga": [
        3956
    ],
    "sate": [
        3966
    ],
    "southern kisi": [
        3972
    ],
    "shyam": [
        3974
    ],
    "s’gaw": [
        3976,
        3977
    ],
    "s'gaw karen": [
        3976,
        3977
    ],
    "sgaw": [
        3976,
        3977
    ],
    "s’gau": [
        3976,
        3977
    ],
    "s’gaw kayin": [
        3976,
        3977
    ],
    "sabar": [
        3979,
        7101,
        7102,
        7103,
        7104
    ],
    "sohou kurti": [
        3994
    ],
    "sohou": [
        3994
    ],
    "south kati": [
        3999
    ],
    "south muyu": [
        3999
    ],
    "simplifié": [
        4001
    ],
    "simbu": [
        4018
    ],
    "sueo": [
        4055
    ],
    "suhwa": [
        4055
    ],
    "sersifar tannin": [
        4059
    ],
    "sersifar": [
        4059
    ],
    "segar tor": [
        4077
    ],
    "segar": [
        4077
    ],
    "sara kaba dem": [
        4079
    ],
    "sara kaba deme": [
        4079
    ],
    "sara kaba ɗem": [
        4079
    ],
    "sàra": [
        4079
    ],
    "sikwangali": [
        4086
    ],
    "sara kaba": [
        6717,
        4093
    ],
    "sara kaba náà": [
        4093
    ],
    "san salvador kongo": [
        4096
    ],
    "smärky": [
        4118
    ],
    "smärki": [
        4118
    ],
    "smärky kanum": [
        4118
    ],
    "sɔkɔwɛlɩ": [
        4137
    ],
    "sokuya": [
        4137
    ],
    "sokya": [
        4137
    ],
    "santiam": [
        4143
    ],
    "syer-tenyer": [
        4162
    ],
    "sugut dusun": [
        4178
    ],
    "sugut": [
        4178
    ],
    "sugut kadazan": [
        4178
    ],
    "seruawan": [
        4182
    ],
    "subanen, southern": [
        4186
    ],
    "subanen": [
        4186,
        6800,
        7159,
        7267
    ],
    "subanun": [
        4186,
        7267
    ],
    "sinubanen": [
        4186
    ],
    "southern subanen": [
        4186
    ],
    "sefardita": [
        4189,
        4190,
        4191
    ],
    "sepharadim": [
        4189,
        4190,
        4191
    ],
    "sefardi": [
        4189,
        4190,
        4191
    ],
    "sepharadi": [
        4189,
        4190,
        4191
    ],
    "sephardi": [
        4189,
        4190,
        4191
    ],
    "sephardic": [
        4189,
        4190,
        4191
    ],
    "shpanyol": [
        4189,
        4190,
        4191
    ],
    "shpanyolit": [
        4189,
        4190,
        4191
    ],
    "spanyol": [
        4189,
        4190,
        4191
    ],
    "spanyolit": [
        4189,
        4190,
        4191
    ],
    "spanyolo": [
        4189,
        4190,
        4191
    ],
    "swangla": [
        4192,
        4193
    ],
    "shahmukhi": [
        4196,
        4197,
        4198,
        4200
    ],
    "sengwe": [
        4206
    ],
    "shen": [
        4206
    ],
    "shen-gwe": [
        4206
    ],
    "south loloda": [
        4211
    ],
    "săsească": [
        4217
    ],
    "siweberjesch såksesch": [
        4217
    ],
    "siweberjesch": [
        4217
    ],
    "såksesch": [
        4217
    ],
    "skat": [
        4226
    ],
    "sekak": [
        4244
    ],
    "sawang": [
        4244
    ],
    "seka": [
        4244,
        6938
    ],
    "sekah": [
        4244
    ],
    "son": [
        4249
    ],
    "shungo": [
        4263
    ],
    "shunhu": [
        4263
    ],
    "shile": [
        4306
    ],
    "shitta": [
        4307
    ],
    "shi": [
        6852,
        4315
    ],
    "sang": [
        4315
    ],
    "shing saapa": [
        4317
    ],
    "shing": [
        4317
    ],
    "saapa": [
        4317
    ],
    "syingsaaba": [
        4317
    ],
    "suryoyo": [
        4320,
        7268,
        7720,
        7721
    ],
    "slai": [
        4326
    ],
    "salien": [
        4327
    ],
    "slatlemuk": [
        4335,
        4336
    ],
    "statimc": [
        4335,
        4336
    ],
    "stlatliumh": [
        4335,
        4336
    ],
    "stl’atl’imc": [
        4335,
        4336
    ],
    "stl’atl’imx": [
        4335,
        4336
    ],
    "st’at’imcets": [
        4335,
        4336
    ],
    "sekpele": [
        4338
    ],
    "sɛkpɛlé": [
        4338
    ],
    "sekpelé": [
        4338
    ],
    "southern lisu": [
        4341,
        4342
    ],
    "sindang": [
        4345
    ],
    "south murri": [
        4356
    ],
    "south lembata": [
        4398
    ],
    "singali": [
        4406,
        4407,
        4408
    ],
    "sugali": [
        4406,
        4407,
        4408
    ],
    "sukali": [
        4406,
        4407,
        4408
    ],
    "southern murut": [
        4425
    ],
    "south central banda": [
        4431
    ],
    "saluan": [
        4443
    ],
    "silozi": [
        4467
    ],
    "serotse": [
        4467
    ],
    "south lorung": [
        4485
    ],
    "southern lohorung": [
        4485
    ],
    "southern lorung": [
        4485
    ],
    "southern yamphu": [
        4485
    ],
    "sasar": [
        4488
    ],
    "saamya-gwe": [
        4497
    ],
    "saamia": [
        4497
    ],
    "samia": [
        4497
    ],
    "srenge": [
        4501
    ],
    "sivia sign language": [
        4504
    ],
    "sivia": [
        4504
    ],
    "sailau": [
        4533,
        4534,
        4535
    ],
    "sound": [
        4536,
        6946
    ],
    "southern luri": [
        4541
    ],
    "salwoeng": [
        4545
    ],
    "saveung": [
        4545
    ],
    "swoeng": [
        4545
    ],
    "southwest lamaholot": [
        4557
    ],
    "si-luyana": [
        4563
    ],
    "san jerónimo tecóatl mazatec": [
        4571
    ],
    "southern nochixtlan mixtec": [
        4572
    ],
    "socé": [
        4586,
        4587
    ],
    "southern malinke": [
        4587,
        4588,
        4589
    ],
    "southern maninka": [
        4587,
        4588,
        4589
    ],
    "san francisco matlatzinca": [
        4593
    ],
    "sateré-mawé": [
        4595
    ],
    "satere mawe": [
        4595
    ],
    "satere": [
        4595
    ],
    "sataré": [
        4595
    ],
    "sataré-maué": [
        4595
    ],
    "sateré": [
        4595
    ],
    "straits malay": [
        4605
    ],
    "straits": [
        7175,
        4605
    ],
    "sambo": [
        4613
    ],
    "sancá": [
        4614
    ],
    "sanja": [
        4614
    ],
    "sanka": [
        4614
    ],
    "sarangani manobo": [
        4617
    ],
    "salug-tigwa manobo": [
        4618
    ],
    "salug-tigwa": [
        4618
    ],
    "sola": [
        7047,
        4624,
        9131,
        9142,
        9145
    ],
    "sharanahua": [
        4628
    ],
    "sharanahuan tsain": [
        4628
    ],
    "sharanahuan": [
        4628
    ],
    "shawãdawa": [
        4628
    ],
    "sharanawa": [
        4628
    ],
    "shawanauá": [
        4628
    ],
    "shawã": [
        4628
    ],
    "soto": [
        4632
    ],
    "so’to": [
        4632
    ],
    "secoya": [
        6797,
        4636
    ],
    "serani": [
        4637
    ],
    "southeastern mixe": [
        4639
    ],
    "south makaa": [
        4640
    ],
    "south mekaa": [
        4640
    ],
    "south watut": [
        4649
    ],
    "soq": [
        4653
    ],
    "songo": [
        5707,
        7038,
        4665
    ],
    "santa lucía monteverde mixtec": [
        4673
    ],
    "suruí do pará": [
        4679
    ],
    "suruí": [
        4679,
        7120
    ],
    "sororos": [
        4679
    ],
    "suruí do tocantins": [
        4679
    ],
    "suroeste": [
        4686,
        5356,
        7560,
        7680,
        7833,
        8127
    ],
    "southeastern ocotepec mixtec": [
        4686
    ],
    "southwestern tlaxiaco mixtec": [
        4686
    ],
    "satun": [
        4695,
        4694
    ],
    "satun malay": [
        4694,
        4695
    ],
    "sahrawi": [
        4704,
        4705
    ],
    "sulaka": [
        4704,
        4705
    ],
    "suraka": [
        4704,
        4705
    ],
    "suraxxé": [
        4704,
        4705
    ],
    "sulsel indonesian": [
        4725
    ],
    "sulsel": [
        4725
    ],
    "shimbwera": [
        4730
    ],
    "southern burun": [
        4735
    ],
    "standard malagasy": [
        4736,
        4738
    ],
    "shimalilia": [
        4757
    ],
    "shɨmalɨla": [
        4757
    ],
    "sempukushu": [
        4786
    ],
    "san esteban atatlahuca mixteco": [
        4792
    ],
    "south central tlaxiaco mixtec": [
        4792
    ],
    "sabean": [
        4795
    ],
    "sabe’in": [
        4795
    ],
    "subbi": [
        4795
    ],
    "santo": [
        8987,
        6933,
        7457,
        7576,
        4796,
        5229,
        9144
    ],
    "santo tomás ocotepec mixtec": [
        4796
    ],
    "san miguel el grande mixtec": [
        4798
    ],
    "southern puebla mixtec": [
        4812
    ],
    "savi̱ꞌ": [
        4816
    ],
    "sav": [
        4819,
        5205,
        5223
    ],
    "san juan colorado mixtec": [
        4819
    ],
    "secumne": [
        4820
    ],
    "sekumne": [
        4820
    ],
    "san chi": [
        4824,
        4877
    ],
    "shanzi yao": [
        4824
    ],
    "shanzi": [
        4824
    ],
    "ship": [
        4835
    ],
    "sauria paharia": [
        4836,
        4837
    ],
    "sauria": [
        4836,
        4837
    ],
    "sawriya malto": [
        4836,
        4837
    ],
    "sawriya": [
        4836,
        4837
    ],
    "siliput": [
        4849
    ],
    "seleput": [
        4849
    ],
    "sokorok": [
        4849
    ],
    "silacayoapan": [
        4864
    ],
    "silacayoapan mixtec": [
        4864
    ],
    "san chay": [
        4877
    ],
    "sán-chi": [
        4877
    ],
    "saker": [
        4889
    ],
    "siawi": [
        4916
    ],
    "siafli": [
        4916
    ],
    "siwai": [
        4916,
        6885
    ],
    "salamaikã": [
        4938
    ],
    "salamãi": [
        4938
    ],
    "sanamaica": [
        4938
    ],
    "sanamaiká": [
        4938
    ],
    "sanamaykã": [
        4938
    ],
    "southern mnong": [
        4949
    ],
    "sougb": [
        4957
    ],
    "sogh": [
        4957
    ],
    "salakahadi": [
        4980
    ],
    "shekkacho": [
        4981,
        4982
    ],
    "silisili": [
        4995
    ],
    "southern tlaxiaco mixtec": [
        4996
    ],
    "sula mangoli": [
        5012
    ],
    "somage": [
        5014
    ],
    "somahai": [
        5014
    ],
    "sumohai": [
        5014
    ],
    "south marquesan": [
        5021
    ],
    "soow huhelia": [
        5024
    ],
    "soow": [
        5024
    ],
    "shir": [
        5029
    ],
    "sunwadia": [
        5040
    ],
    "syangja magar": [
        5042
    ],
    "syangja": [
        5042
    ],
    "southeast marind": [
        5066
    ],
    "sankaran": [
        5075
    ],
    "sankaran maninka": [
        5075
    ],
    "sankarankan": [
        5075
    ],
    "sabah malay": [
        5081
    ],
    "sabah malay dialect": [
        5081
    ],
    "sabena": [
        5110
    ],
    "southern binukidnon": [
        5123
    ],
    "sekayu": [
        5133
    ],
    "samba bali": [
        5138
    ],
    "siegu": [
        5144
    ],
    "southern-eastern mongolian": [
        5155,
        5156
    ],
    "southern-eastern": [
        5155,
        5156
    ],
    "semambu": [
        5170
    ],
    "semembu": [
        5170
    ],
    "sumambu": [
        5170
    ],
    "sumambu-tagal": [
        5170
    ],
    "sumambuq": [
        5170
    ],
    "shuthun": [
        5173
    ],
    "sar": [
        5185,
        8245
    ],
    "sara madjingay": [
        5185
    ],
    "sàᶉ̄": [
        5185
    ],
    "sungwadaga": [
        5187
    ],
    "salon": [
        5193,
        5194
    ],
    "salong": [
        5193,
        5194
    ],
    "selong": [
        5193,
        5194
    ],
    "selung": [
        5193,
        5194
    ],
    "striped arm hmong": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "striped": [
        5197,
        5198,
        5199,
        5200,
        5201,
        8804,
        8792
    ],
    "striped hmong": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "segura": [
        5206
    ],
    "sanbalbe": [
        5210
    ],
    "south central mixe": [
        5221
    ],
    "sávi": [
        5226
    ],
    "southeastern nochixtlán mixtec": [
        5229
    ],
    "saka": [
        5843,
        6932,
        8638,
        5231,
        5232
    ],
    "sara mbai": [
        5233
    ],
    "sénoufo, mamara": [
        5241
    ],
    "suroa": [
        5253
    ],
    "santa maría zacatepec mixtec": [
        5255
    ],
    "southern putla mixtec": [
        5255
    ],
    "southern nambikuára": [
        5284
    ],
    "southern nambikwara": [
        5284
    ],
    "southern fujian": [
        5293,
        5294,
        5295,
        5296,
        5297
    ],
    "southern min": [
        5293,
        5294,
        5295,
        5296,
        5297
    ],
    "sherpa": [
        8639,
        8640,
        5298,
        6732
    ],
    "sj": [
        5309
    ],
    "svalbard and jan mayen": [
        5309
    ],
    "svalbard": [
        5309
    ],
    "sopfomie": [
        5317
    ],
    "sopfomo": [
        5317
    ],
    "sopvoma": [
        5317
    ],
    "sopwama": [
        5317
    ],
    "southern angami": [
        5317
    ],
    "southern ngbandi": [
        5331
    ],
    "sibe": [
        5348,
        6899,
        6900,
        6901,
        6902
    ],
    "sibbe": [
        5348
    ],
    "sibe-nagovisi": [
        5348
    ],
    "southwestern puebla nahuatl": [
        5356
    ],
    "sindebele": [
        5358
    ],
    "sofala": [
        5361
    ],
    "southeast shona": [
        5361
    ],
    "samba leko": [
        5366
    ],
    "samba leeko": [
        5366
    ],
    "suntai": [
        5366
    ],
    "saxon, low": [
        5375
    ],
    "southeast ngada": [
        5389
    ],
    "sangs-rgyas": [
        5405
    ],
    "sangyas": [
        5405
    ],
    "santa maría la alta nahuatl": [
        5467
    ],
    "shinyiha": [
        5474,
        5804
    ],
    "southwest barito": [
        5476
    ],
    "southern nicobarese": [
        5477
    ],
    "southeastern kolami": [
        5485
    ],
    "southern hema": [
        5490
    ],
    "shinkoya": [
        5511
    ],
    "saba": [
        6658,
        5539
    ],
    "southern yali": [
        5550
    ],
    "selatan": [
        5550
    ],
    "southern santa cruz": [
        5560
    ],
    "sarngam": [
        5563
    ],
    "si:rti": [
        5569
    ],
    "small nambas": [
        5582
    ],
    "small": [
        6801,
        5582
    ],
    "sor": [
        5596
    ],
    "shwóŋò ngiembɔɔn": [
        5599
    ],
    "shwóŋò": [
        5599
    ],
    "shwoge": [
        5599
    ],
    "southern nuni": [
        5614
    ],
    "shiping-jianshui nisu": [
        5634
    ],
    "shiping-jianshui": [
        5634
    ],
    "shiping-jianshui yi": [
        5634
    ],
    "southeastern puebla nahuatl": [
        5645
    ],
    "southern jale": [
        5648
    ],
    "southern nago": [
        5652
    ],
    "south ndebele": [
        5661,
        5662
    ],
    "southern ndebele": [
        5661,
        5662
    ],
    "southern rengma": [
        5666
    ],
    "southern rengma naga": [
        5666
    ],
    "sangtam": [
        5681
    ],
    "sangtam naga": [
        5681
    ],
    "southern nisu": [
        5684
    ],
    "senga": [
        5685
    ],
    "shaka": [
        5687
    ],
    "sumi": [
        5693
    ],
    "sema": [
        5693
    ],
    "sumi naga": [
        5693
    ],
    "sümi": [
        5693
    ],
    "sotho, northern": [
        5695,
        5696
    ],
    "sesotho sa leboa": [
        5695,
        5696
    ],
    "sesotho": [
        5695,
        7156,
        7157,
        5696
    ],
    "sepedi": [
        5695,
        5696
    ],
    "scotia": [
        5699
    ],
    "scotian": [
        5699
    ],
    "signs": [
        5699,
        6310
    ],
    "sierra negra nahuatl": [
        5704
    ],
    "southwestern nisu": [
        5705
    ],
    "sungu": [
        5707,
        7572
    ],
    "southern maidu": [
        5709
    ],
    "sakaji": [
        5711
    ],
    "sakati": [
        5711
    ],
    "sanagage": [
        5711
    ],
    "sangaji": [
        5711
    ],
    "sankaji": [
        5711
    ],
    "santa cruz": [
        5720
    ],
    "somara": [
        5722
    ],
    "somra": [
        5722
    ],
    "sogap": [
        5727
    ],
    "swagup": [
        5727
    ],
    "suma": [
        7078,
        5749
    ],
    "saot wes tanna": [
        5765
    ],
    "saot": [
        5765
    ],
    "saotwes": [
        5765
    ],
    "southwest tanna": [
        5765
    ],
    "sirio": [
        5768
    ],
    "south nuaulu": [
        5777
    ],
    "sochile": [
        5811
    ],
    "sokile": [
        5811
    ],
    "sakara": [
        5816
    ],
    "sangrima": [
        5817
    ],
    "sengima": [
        5817
    ],
    "southern bontok": [
        5827
    ],
    "severn ojibwa": [
        5865,
        5866
    ],
    "severn": [
        5865,
        5866
    ],
    "saulteau": [
        5868,
        5869
    ],
    "saulteaux": [
        5868,
        5869
    ],
    "saulteaux ojibwe": [
        5868,
        5869
    ],
    "syilx": [
        5870,
        5871
    ],
    "southern olonetsian": [
        5896
    ],
    "songola": [
        5910,
        7027
    ],
    "south tairora": [
        5917
    ],
    "selknam": [
        5920
    ],
    "shelknam": [
        5920
    ],
    "sepa": [
        7049,
        7052,
        5924
    ],
    "sartang": [
        5929,
        5930
    ],
    "seletar": [
        5958
    ],
    "sundanese": [
        5974,
        7183,
        7184,
        7185,
        7186
    ],
    "southern one": [
        5978
    ],
    "sierra oriental otomi": [
        5987
    ],
    "sierra otomi": [
        5987
    ],
    "santiago mexquititlán otomi": [
        5989
    ],
    "state of mexico otomi": [
        5991
    ],
    "southeastern otomí": [
        5997
    ],
    "samo": [
        6694,
        6978,
        7167,
        7274,
        6005,
        7042
    ],
    "simagahi": [
        6010
    ],
    "sísuan": [
        6030,
        6031
    ],
    "siyarui": [
        6034
    ],
    "shoshone": [
        6836,
        6035
    ],
    "shoshoni": [
        6836,
        6035
    ],
    "seco": [
        6041
    ],
    "southern popoloca": [
        6045,
        6251
    ],
    "san vicente coyotepec popoloca": [
        6046
    ],
    "southern pame": [
        6056,
        6223
    ],
    "southern pashto": [
        6057
    ],
    "southwestern pashto": [
        6057
    ],
    "santa inés ahuatempan popoloca": [
        6060
    ],
    "shuihu": [
        6062,
        6063
    ],
    "silver palaung": [
        6065,
        6066,
        6486
    ],
    "silver": [
        6065,
        6066,
        6486
    ],
    "southern ta’ang": [
        6065
    ],
    "southern palaung": [
        6066
    ],
    "seramar": [
        6067
    ],
    "south mori": [
        6085
    ],
    "salt pomo": [
        6093
    ],
    "salt": [
        6093,
        6949
    ],
    "southern pomo": [
        6103
    ],
    "southern sudan arabic": [
        6111
    ],
    "sudanese arabic creole": [
        6111
    ],
    "sudanese creole arabic": [
        6111
    ],
    "seng": [
        6121
    ],
    "singsily": [
        6129
    ],
    "sinsali": [
        6129
    ],
    "simiranch": [
        6143
    ],
    "solomons pidgin": [
        6158
    ],
    "solomons": [
        6158
    ],
    "sanbiau": [
        6163
    ],
    "shina, kohistani": [
        6190
    ],
    "shina": [
        6190,
        6728,
        6729
    ],
    "shwe": [
        6191
    ],
    "shwe palaung": [
        6191
    ],
    "samlung": [
        6191
    ],
    "sénoufo, palaka": [
        6196
    ],
    "san marcos tlacoyalco popoloca": [
        6197
    ],
    "san marcos tlalcoyalco popoloca": [
        6197
    ],
    "southwest palawano": [
        6199
    ],
    "selusien ten out voum": [
        6203
    ],
    "selusien": [
        6203
    ],
    "southern pumi": [
        6210
    ],
    "sabir": [
        6212
    ],
    "south pame": [
        6223
    ],
    "san juan atzingo popoloca": [
        6251
    ],
    "sona": [
        7040,
        6256
    ],
    "southeastern pomo": [
        6257
    ],
    "sayula": [
        6262
    ],
    "sayula popoluca": [
        6262
    ],
    "san felipe otlaltepec popoloca": [
        6265
    ],
    "shipogolu": [
        6267
    ],
    "san luís temalacayuca popoloca": [
        6277
    ],
    "standard wa": [
        6291
    ],
    "sharqi": [
        6306
    ],
    "sign talk": [
        6310
    ],
    "semendo": [
        6311
    ],
    "serawai": [
        6311
    ],
    "southwest pashai": [
        6313
    ],
    "southwest pashayi": [
        6313
    ],
    "southeast pashai": [
        6314
    ],
    "southeast pashayi": [
        6314
    ],
    "sauraseni prākrit": [
        6324,
        6325
    ],
    "sauraseni": [
        6324,
        6325
    ],
    "sandwich": [
        6326
    ],
    "salu": [
        6350
    ],
    "sierras": [
        6354
    ],
    "sira": [
        7237,
        6374
    ],
    "southern wintun": [
        6377
    ],
    "samobi": [
        6379
    ],
    "samohai": [
        6379
    ],
    "saprek": [
        6379
    ],
    "stimul": [
        6379
    ],
    "shu": [
        6380
    ],
    "southeastern krumen": [
        6384
    ],
    "suˎ": [
        6391
    ],
    "shimi": [
        6397,
        6429,
        6438,
        8214,
        6399,
        6400,
        6401,
        6407,
        6412,
        6419,
        6420,
        6422,
        6423,
        6424,
        6432,
        6444
    ],
    "salcedo quichua": [
        6399
    ],
    "salcedo": [
        6399
    ],
    "serrano": [
        6791,
        6401,
        9171
    ],
    "sipakapense": [
        6405
    ],
    "sipacapa": [
        6405
    ],
    "sipacapa quiché": [
        6405
    ],
    "sipacapense": [
        6405
    ],
    "sipacapeño": [
        6405
    ],
    "southern pastaza quechua": [
        6407
    ],
    "santiago del estero quichua": [
        6410
    ],
    "santiagueño quichua": [
        6410
    ],
    "santiagueño": [
        6410
    ],
    "sakapulteko": [
        6411
    ],
    "sacapulas k’iche’": [
        6411
    ],
    "sacapulas": [
        6411
    ],
    "sacapulteco": [
        6411
    ],
    "san rafael-huariaca quechua": [
        6415
    ],
    "saraguro quichua": [
        6420
    ],
    "saraguro": [
        6420
    ],
    "santa rosa quechua": [
        6424
    ],
    "santarrosino": [
        6424
    ],
    "san martin kechwa": [
        6426
    ],
    "san martín quechua": [
        6426
    ],
    "southern huancayo quechua": [
        6427
    ],
    "sarayacu quichua": [
        6429
    ],
    "sarayacu": [
        6429
    ],
    "sihuas": [
        6434
    ],
    "sihuas ancash quechua": [
        6434
    ],
    "salasaca": [
        6439
    ],
    "shimibi": [
        6439
    ],
    "salasaca highland quichua": [
        6439
    ],
    "salasaca quichua": [
        6439
    ],
    "salasaca shimibi": [
        6439
    ],
    "salasaka quichua": [
        6439
    ],
    "salasaka": [
        6439
    ],
    "south conchucos quechua": [
        6441
    ],
    "southern conchucos ancash quechua": [
        6441
    ],
    "southern qiang": [
        6445
    ],
    "santa ana de tusi pasco quechua": [
        6446
    ],
    "shausha": [
        6448
    ],
    "shausha wanka quechua": [
        6448
    ],
    "saam": [
        6471,
        6891,
        6907,
        6974,
        6980,
        6981
    ],
    "saam rai": [
        6471
    ],
    "saama kha": [
        6471
    ],
    "saama": [
        6471
    ],
    "samakha": [
        6471
    ],
    "sampang": [
        6476
    ],
    "sampang gun": [
        6476
    ],
    "sampang gung": [
        6476
    ],
    "sampang kha": [
        6476
    ],
    "sampange rai": [
        6476
    ],
    "sampange": [
        6476
    ],
    "sangpang": [
        6476
    ],
    "sangpang gun": [
        6476
    ],
    "sangpang gîn": [
        6476
    ],
    "sangpang kha": [
        6476
    ],
    "shan rumai": [
        6486
    ],
    "san borjano": [
        6505
    ],
    "saukiya khun": [
        6508
    ],
    "saukiya": [
        6508
    ],
    "southern roglai": [
        6511
    ],
    "south polish romani": [
        6542
    ],
    "sárvika romá": [
        6542
    ],
    "sárvika": [
        6542
    ],
    "sk": [
        6542,
        6620,
        6910,
        6911,
        7219
    ],
    "slovakia": [
        6542,
        6620,
        6910,
        6911,
        7219
    ],
    "scandoromani": [
        6546,
        6561
    ],
    "serbia": [
        6553,
        6601,
        6829,
        7088,
        7090,
        7092,
        8906
    ],
    "sinte": [
        6556
    ],
    "sasítka romá": [
        6556
    ],
    "sasítka": [
        6556
    ],
    "sinte romani": [
        6556
    ],
    "sinti": [
        6556
    ],
    "sintitikes": [
        6556
    ],
    "sinto-manush": [
        6556
    ],
    "semnelor": [
        6559
    ],
    "semenelor": [
        6559
    ],
    "svensk rommani": [
        6561
    ],
    "svensk": [
        6561
    ],
    "swedish": [
        7209,
        7210,
        7211,
        7212,
        7239,
        6561
    ],
    "shironga": [
        6569
    ],
    "shiyabe": [
        6583
    ],
    "sale": [
        6625
    ],
    "s-samrit": [
        6649
    ],
    "samrah rāziḥīt": [
        6649
    ],
    "samrah": [
        6649
    ],
    "samrit rāziḥ": [
        6649
    ],
    "samrit": [
        6649
    ],
    "sanskrit": [
        6650,
        6651,
        6652,
        6653,
        6654,
        6655,
        6656,
        6657
    ],
    "sanskrit bhasha": [
        6650,
        6651,
        6652,
        6653,
        6654,
        6655,
        6656,
        6657
    ],
    "sac and fox": [
        6660
    ],
    "sac": [
        6660
    ],
    "sauk-fox": [
        6660
    ],
    "sandawe": [
        6661
    ],
    "sandaui": [
        6661
    ],
    "sandaweeki": [
        6661
    ],
    "sandawegki": [
        6661
    ],
    "sandawi": [
        6661
    ],
    "sandawso": [
        6661
    ],
    "sandwe": [
        6661
    ],
    "sabanê": [
        6662
    ],
    "sabanês": [
        6662
    ],
    "sabones": [
        6662
    ],
    "sowainte": [
        6662
    ],
    "safaliba": [
        6663
    ],
    "safale̱ba": [
        6663
    ],
    "safalaba": [
        6663
    ],
    "safalba": [
        6663
    ],
    "safali": [
        6663
    ],
    "sakha": [
        6664,
        6665
    ],
    "sahu": [
        6666
    ],
    "sahu’u": [
        6666
    ],
    "sa’u": [
        6666
    ],
    "sake": [
        6667
    ],
    "shake": [
        6667
    ],
    "samaritan aramaic": [
        6668,
        6669,
        6670
    ],
    "samaritan": [
        6668,
        6669,
        6670,
        6975,
        6976,
        6977
    ],
    "shamerim": [
        6668,
        6669,
        6670,
        6975,
        6976,
        6977
    ],
    "sause": [
        6671
    ],
    "seuce": [
        6671
    ],
    "samburu": [
        6672
    ],
    "sambur": [
        6672
    ],
    "sampur": [
        6672
    ],
    "saraveca": [
        6673
    ],
    "sasak": [
        6674,
        6675
    ],
    "santhali": [
        6676,
        6677,
        6678,
        6679,
        6680,
        7976,
        7977,
        7978,
        7979
    ],
    "sainti": [
        6676,
        6677,
        6678,
        6679,
        6680
    ],
    "samtali": [
        6676,
        6677,
        6678,
        6679,
        6680
    ],
    "sandal": [
        6676,
        6677,
        6678,
        6679,
        6680
    ],
    "sangtal": [
        6676,
        6677,
        6678,
        6679,
        6680
    ],
    "santal": [
        6676,
        6677,
        6678,
        6679,
        6680
    ],
    "santali": [
        6676,
        6677,
        6678,
        6679,
        6680
    ],
    "santhal": [
        6676,
        6677,
        6678,
        6679,
        6680
    ],
    "santhiali": [
        6676,
        6677,
        6678,
        6679,
        6680
    ],
    "satar": [
        6676,
        6677,
        6678,
        6679,
        6680,
        7976,
        7977,
        7978,
        7979
    ],
    "sentali": [
        6676,
        6677,
        6678,
        6679,
        6680
    ],
    "sonthal": [
        6676,
        6677,
        6678,
        6679,
        6680
    ],
    "saleman": [
        6681
    ],
    "sawai": [
        7294,
        6681
    ],
    "seleman": [
        6681
    ],
    "saafi-saafi": [
        6682,
        6683
    ],
    "saafen": [
        6682,
        6683
    ],
    "saafi": [
        6682,
        6683
    ],
    "safen": [
        6682,
        6683
    ],
    "safi": [
        6682,
        6683
    ],
    "safi-safi": [
        6682,
        6683
    ],
    "sereer saafen": [
        6682,
        6683
    ],
    "sereer": [
        6682,
        6683,
        7116,
        7117
    ],
    "serer-safen": [
        6682,
        6683
    ],
    "serere-saafen": [
        6682,
        6683
    ],
    "sawi": [
        6684,
        6752
    ],
    "sawuy": [
        6684
    ],
    "south pentecost language": [
        6685
    ],
    "saya": [
        6686
    ],
    "sayanci": [
        6686
    ],
    "sayara": [
        6686
    ],
    "sayawa": [
        6686
    ],
    "seiyara": [
        6686
    ],
    "seya": [
        6686
    ],
    "seyawa": [
        6686
    ],
    "saurashtra": [
        6687,
        6688,
        6689,
        6690
    ],
    "saurashtri": [
        6687,
        6688,
        6689,
        6690
    ],
    "sourashtra": [
        6687,
        6688,
        6689,
        6690
    ],
    "sowrashtra": [
        6687,
        6688,
        6689,
        6690
    ],
    "sara ngambai": [
        6691
    ],
    "sara-ngambay": [
        6691
    ],
    "simbo": [
        6692
    ],
    "sibo": [
        6692,
        6899,
        6900,
        6901,
        6902
    ],
    "samo, southern": [
        6694
    ],
    "sane": [
        6694,
        7167
    ],
    "southern samo": [
        6694,
        7042
    ],
    "saliba": [
        6695
    ],
    "saliba-logea": [
        6695
    ],
    "shabo": [
        6696
    ],
    "seget": [
        6697
    ],
    "sori-harengan": [
        6698
    ],
    "seti": [
        6699
    ],
    "surbakhal": [
        6700
    ],
    "sourbakhal": [
        6700
    ],
    "safwa": [
        6701
    ],
    "shisafwa": [
        6701
    ],
    "sambal, botolan": [
        6702
    ],
    "sagala": [
        6703,
        7446
    ],
    "sagalla": [
        7446,
        6703
    ],
    "saghala": [
        6703,
        7446
    ],
    "southern kisagala": [
        6703
    ],
    "sindhi bhil": [
        6704
    ],
    "sabüm": [
        6705
    ],
    "sangu": [
        6706,
        7008
    ],
    "sangi": [
        6706,
        7260
    ],
    "sango": [
        6804,
        6999,
        6706
    ],
    "sangu (tanzania)": [
        6706
    ],
    "shisango": [
        6706
    ],
    "shisangu": [
        6706
    ],
    "sirva": [
        6707
    ],
    "sileibi": [
        6707
    ],
    "sembakung": [
        6708
    ],
    "sembakoeng": [
        6708
    ],
    "sembakong": [
        6708
    ],
    "sembakung murut": [
        6708
    ],
    "simbakong": [
        6708
    ],
    "sesubea": [
        6709
    ],
    "sesubiya": [
        6709
    ],
    "subia": [
        6709
    ],
    "subiya": [
        6709
    ],
    "supia": [
        6709
    ],
    "sukubatom": [
        6710
    ],
    "sukubatong": [
        6710
    ],
    "stod bhoti": [
        6711,
        6712
    ],
    "stod": [
        6711,
        6712
    ],
    "stod-kad": [
        6711,
        6712
    ],
    "sabine": [
        6713
    ],
    "seberuang": [
        6715
    ],
    "soli": [
        6716
    ],
    "sardinian": [
        6718,
        6749,
        6758,
        7114
    ],
    "sard": [
        6718
    ],
    "sardarese": [
        6718
    ],
    "sardinian, logudorese": [
        6718
    ],
    "sach": [
        6719
    ],
    "san miguel french creole": [
        6722
    ],
    "san miguel creole french": [
        6722
    ],
    "sakachep": [
        6724
    ],
    "sakechep": [
        6724
    ],
    "sri lankan malay creole": [
        6725
    ],
    "sri": [
        6725,
        7083,
        6864,
        6865,
        7298,
        8070
    ],
    "sri lankan creole malay": [
        6725
    ],
    "sri lankan malay": [
        6725
    ],
    "sri lanka": [
        6725,
        6864,
        6865,
        7083,
        7298,
        8070
    ],
    "sadri": [
        6726,
        6727,
        6762,
        6763,
        6764
    ],
    "sadan": [
        6726,
        6727,
        6747
    ],
    "sadana": [
        6726,
        6727
    ],
    "sadani": [
        6726,
        6727
    ],
    "sadati": [
        6726,
        6727
    ],
    "sadhan": [
        6726,
        6727
    ],
    "sadhari": [
        6726,
        6727
    ],
    "sadna": [
        6726,
        6727
    ],
    "sadrias khatoya": [
        6726,
        6727
    ],
    "sadrias": [
        6726,
        6727
    ],
    "sadrik": [
        6726,
        6727
    ],
    "santri": [
        6726,
        6727
    ],
    "siddri": [
        6726,
        6727
    ],
    "sradri": [
        6726,
        6727
    ],
    "shinaki": [
        6728,
        6729
    ],
    "sina": [
        6728,
        6729,
        7321
    ],
    "sicilian": [
        6730
    ],
    "sicilianu": [
        6730
    ],
    "siculu": [
        6730
    ],
    "scotch": [
        6731
    ],
    "sa'och": [
        6733
    ],
    "slavey, north": [
        6734,
        6735
    ],
    "satúotine yatí": [
        6734,
        6735
    ],
    "satúotine": [
        6734,
        6735
    ],
    "southern katang": [
        6736
    ],
    "shumcho": [
        6737
    ],
    "shumcu": [
        6737
    ],
    "sumcho": [
        6737
    ],
    "sumchu": [
        6737
    ],
    "sumtsu": [
        6737
    ],
    "sheni": [
        6738
    ],
    "seni": [
        6738
    ],
    "shaini": [
        6738
    ],
    "shani": [
        6738
    ],
    "shenanci": [
        6738
    ],
    "shenne": [
        6738
    ],
    "sha": [
        6739,
        6845,
        6846,
        6847,
        6848,
        9146,
        9147
    ],
    "sicel": [
        6740
    ],
    "sada": [
        6747
    ],
    "sadang": [
        6747
    ],
    "sa’dan": [
        6747
    ],
    "sa’dansche": [
        6747
    ],
    "south toraja": [
        6747
    ],
    "shabak": [
        6748
    ],
    "sardinian, sassarese": [
        6749
    ],
    "sassarese": [
        6749
    ],
    "sassarese sardinian": [
        6749
    ],
    "skrubu": [
        6750
    ],
    "srubu": [
        6750
    ],
    "surubu": [
        6750
    ],
    "sarli": [
        6751
    ],
    "sarliya": [
        6751
    ],
    "sauji": [
        6752
    ],
    "southern kurdish": [
        6753
    ],
    "suundi": [
        6754
    ],
    "soundi": [
        6754
    ],
    "suundi de kifouma": [
        6754
    ],
    "suundi de kimongo": [
        6754
    ],
    "sos kundi": [
        6755
    ],
    "sos": [
        6755
    ],
    "soskundi": [
        6755
    ],
    "saudi arabian sign language": [
        6756
    ],
    "semandang": [
        6757,
        6761
    ],
    "sardinian, gallurese": [
        6758
    ],
    "serian": [
        6759
    ],
    "sadong": [
        6759
    ],
    "sadung": [
        6759
    ],
    "sabutan": [
        6759
    ],
    "sherdukpen": [
        6760
    ],
    "semanang": [
        6761
    ],
    "semandang-kualan": [
        6761
    ],
    "simpang": [
        6761
    ],
    "sadri, oraon": [
        6762,
        6763,
        6764
    ],
    "sened": [
        6765
    ],
    "shuadit": [
        6766
    ],
    "shuadi": [
        6766
    ],
    "sarudu": [
        6767
    ],
    "sibu": [
        6768
    ],
    "seduan-banyok": [
        6768
    ],
    "sibu melanau": [
        6768
    ],
    "siduan": [
        6768
    ],
    "siduani": [
        6768
    ],
    "sallands": [
        6769
    ],
    "sallan": [
        6769
    ],
    "salland": [
        6769
    ],
    "saami, north": [
        6770,
        6771
    ],
    "saami": [
        6770,
        6771,
        6866,
        6891,
        6892,
        6907,
        6908,
        6963,
        6970,
        6974,
        6980,
        6981
    ],
    "sámi": [
        6974,
        6770,
        6771,
        6891
    ],
    "sami": [
        6772,
        6773,
        6894,
        6770,
        6771,
        6866,
        6891,
        6892,
        6907,
        6908,
        6963,
        6970,
        6974,
        6980,
        6981
    ],
    "saame": [
        6770,
        6771,
        6970,
        6974,
        6980,
        6981
    ],
    "same": [
        6770,
        6771,
        6963,
        6980,
        6981
    ],
    "samic": [
        6770,
        6771,
        6963,
        6974
    ],
    "sámegiella": [
        6770,
        6771
    ],
    "semai": [
        6774
    ],
    "semay": [
        6774
    ],
    "sengoi": [
        6774
    ],
    "seng’oi": [
        6774
    ],
    "senoi": [
        6774
    ],
    "sénoufo, shempire": [
        6775
    ],
    "shempire": [
        6775
    ],
    "shempire senoufo": [
        6775
    ],
    "shenpire": [
        6775
    ],
    "syempire": [
        6775
    ],
    "sechelt": [
        6776
    ],
    "she shashishalhem": [
        6776
    ],
    "she": [
        6859,
        6776
    ],
    "shashishalhem": [
        6776
    ],
    "sedang": [
        6777
    ],
    "seneca": [
        6778
    ],
    "sénoufo, cebaara": [
        6779
    ],
    "senadi": [
        6779
    ],
    "senari": [
        6779,
        6863
    ],
    "syenere": [
        6779
    ],
    "sénoufo-sénanri": [
        6779
    ],
    "sageju": [
        6780
    ],
    "sena": [
        6781,
        7238
    ],
    "seri": [
        6782
    ],
    "sene": [
        6783
    ],
    "sekani": [
        6784,
        6785
    ],
    "selkup": [
        6786
    ],
    "selkups": [
        6786
    ],
    "shöl khumyt": [
        6786
    ],
    "shöl": [
        6786
    ],
    "shösh gulla": [
        6786
    ],
    "shösh": [
        6786
    ],
    "syusugulla": [
        6786
    ],
    "sénoufo, nanerigé": [
        6787
    ],
    "suarmin": [
        6788
    ],
    "sénoufo, sìcìté": [
        6789
    ],
    "sìcìté": [
        6789
    ],
    "sucite": [
        6789
    ],
    "sìcijuungé": [
        6789
    ],
    "sìcìré": [
        6789
    ],
    "sìcìté sénoufo": [
        6789
    ],
    "sìpììté": [
        6789
    ],
    "sénoufo, senara": [
        6790
    ],
    "senara": [
        6790
    ],
    "senara sénoufo": [
        6790
    ],
    "songhay, koyraboro senni": [
        6792
    ],
    "sentani": [
        6793
    ],
    "serui-laut": [
        6794
    ],
    "sénoufo, nyarafolo": [
        6795
    ],
    "sewa bay": [
        6796
    ],
    "siona-secoya": [
        6797,
        7004
    ],
    "senthang": [
        6798
    ],
    "sentang": [
        6798
    ],
    "senthang chin": [
        6798
    ],
    "subanen, eastern": [
        6800
    ],
    "salugnen": [
        6800
    ],
    "small flowery miao": [
        6801
    ],
    "south african sign language": [
        6802
    ],
    "sasl": [
        6802
    ],
    "sefwi": [
        6803
    ],
    "sehwi": [
        6803
    ],
    "sängö": [
        6804
    ],
    "sangho": [
        6804
    ],
    "surigaonon": [
        6809
    ],
    "sinurigao": [
        6809
    ],
    "segai": [
        6810
    ],
    "segayi": [
        6810
    ],
    "swiss-german sign language": [
        6811
    ],
    "swiss-german": [
        6811
    ],
    "shughni": [
        6812,
        6813,
        6814
    ],
    "shighnani": [
        6812,
        6813,
        6814
    ],
    "shighni": [
        6812,
        6813,
        6814
    ],
    "shughnani": [
        6812,
        6813,
        6814
    ],
    "shughnoni": [
        6812,
        6813,
        6814
    ],
    "shugnan-rushan": [
        6812,
        6813,
        6814
    ],
    "shugni": [
        6812,
        6813,
        6814
    ],
    "ssuga": [
        6815
    ],
    "suga": [
        6815
    ],
    "surgujia": [
        6816
    ],
    "suraji": [
        6816
    ],
    "surguja": [
        6816
    ],
    "surgujia-chhattisgarhi": [
        6816
    ],
    "surjugia": [
        6816
    ],
    "sangkong": [
        6817
    ],
    "singa": [
        6818
    ],
    "sign languages": [
        6819
    ],
    "singpho": [
        6820
    ],
    "sing-fo": [
        6820
    ],
    "sangisari": [
        6821
    ],
    "shahri": [
        6821
    ],
    "sangesari": [
        6821
    ],
    "sangsari": [
        6821
    ],
    "sengiseri": [
        6821
    ],
    "sengsari": [
        6821
    ],
    "sängesäri": [
        6821
    ],
    "sängsari": [
        6821
    ],
    "sängsäri": [
        6821
    ],
    "samogitian": [
        6822
    ],
    "sagtengpa": [
        6823
    ],
    "salas": [
        6824
    ],
    "salas gunung": [
        6824
    ],
    "sebat bet gurage": [
        6825
    ],
    "sebat": [
        6825
    ],
    "sierra leone sign language": [
        6826
    ],
    "sanglechi": [
        6827
    ],
    "sursurunga": [
        6828
    ],
    "shall-zwall": [
        6830
    ],
    "shiriana": [
        6831,
        8486
    ],
    "sonde": [
        6832
    ],
    "soonde": [
        6832
    ],
    "shahi": [
        6833
    ],
    "sheko": [
        6834,
        8453
    ],
    "s'oku noogu": [
        6834
    ],
    "soku": [
        6834
    ],
    "shua-khwe": [
        6835
    ],
    "shuakhwena": [
        6835
    ],
    "sosoni’ ta̲i̲kwappe": [
        6836
    ],
    "sosoni’": [
        6836
    ],
    "soussiya": [
        6837,
        6838,
        6839
    ],
    "southern shilha": [
        6837,
        6838,
        6839
    ],
    "susiya": [
        6837,
        6838,
        6839
    ],
    "shatt": [
        6840,
        7485
    ],
    "shilluk": [
        6841,
        6842
    ],
    "shulla": [
        6841,
        6842
    ],
    "shendu": [
        6843
    ],
    "sandu": [
        6843
    ],
    "shandu": [
        6843
    ],
    "shahrudi": [
        6844
    ],
    "shan bama": [
        6845,
        6846,
        6847,
        6848
    ],
    "shan gyi": [
        6845,
        6846,
        6847,
        6848
    ],
    "shanga": [
        6849
    ],
    "shangawa": [
        6849
    ],
    "shonga": [
        6849
    ],
    "shongawa": [
        6849
    ],
    "shipibo-conibo": [
        6850
    ],
    "shipibo-konibo": [
        6850
    ],
    "sinabo": [
        6850
    ],
    "sala": [
        6851,
        6954,
        8750
    ],
    "shuswap": [
        6853
    ],
    "secwepemc": [
        6853
    ],
    "secwepemctsín": [
        6853
    ],
    "shasta": [
        6854
    ],
    "sastean": [
        6854
    ],
    "shastan": [
        6854
    ],
    "shoa arabic": [
        6855,
        6856
    ],
    "shua arabic": [
        6855,
        6856
    ],
    "shuwa arabic": [
        6855,
        6856
    ],
    "suwa": [
        6855,
        6856
    ],
    "sudanic": [
        6855,
        6856
    ],
    "shehri": [
        6857
    ],
    "sehri": [
        6857
    ],
    "shahari": [
        6857
    ],
    "sheret": [
        6857
    ],
    "shwai": [
        6858
    ],
    "shirumba": [
        6858
    ],
    "shuway": [
        6858
    ],
    "shawia": [
        6860,
        6861,
        6862
    ],
    "shawiya": [
        6860,
        6861,
        6862
    ],
    "sénoufo, syenara": [
        6863
    ],
    "syenara": [
        6863
    ],
    "senare": [
        6863
    ],
    "shenara": [
        6863
    ],
    "syenara senoufo": [
        6863
    ],
    "sinhala": [
        6864,
        6865
    ],
    "singhala": [
        6864,
        6865
    ],
    "singhalese": [
        6864,
        6865
    ],
    "sinhalese": [
        6864,
        6865
    ],
    "saami, akkala": [
        6866
    ],
    "sebop": [
        6867
    ],
    "sabup": [
        6867
    ],
    "sebob": [
        6867
    ],
    "sibop": [
        6867
    ],
    "sidamo": [
        6868,
        6869
    ],
    "sidaamu afoo": [
        6868
    ],
    "sidaamu": [
        6868
    ],
    "simaa": [
        6870
    ],
    "siamou": [
        6871
    ],
    "seme": [
        6871
    ],
    "siemu": [
        6871
    ],
    "siémou": [
        6871
    ],
    "syémou": [
        6871
    ],
    "sému": [
        6871
    ],
    "sisaala": [
        6877,
        7140,
        6872
    ],
    "sisaala-pasaale": [
        6872
    ],
    "southern sisaala": [
        6872
    ],
    "sîshëë": [
        6873
    ],
    "siche": [
        6873
    ],
    "sirhe": [
        6873
    ],
    "shom peng": [
        6874
    ],
    "shom": [
        6874
    ],
    "shobang": [
        6874
    ],
    "shom pen": [
        6874
    ],
    "shompen": [
        6874
    ],
    "shompeng": [
        6874
    ],
    "siboma": [
        6875
    ],
    "sipoma": [
        6875
    ],
    "sikiana": [
        6876
    ],
    "shikiana": [
        6876
    ],
    "sikiuyana": [
        6876
    ],
    "sikiyana": [
        6876
    ],
    "sikiâna": [
        6876
    ],
    "sikïiyana": [
        6876
    ],
    "sisaala, tumulung": [
        6877
    ],
    "sisai": [
        6877,
        7140
    ],
    "sisala tumu": [
        6877
    ],
    "sisala": [
        6877,
        7140
    ],
    "seim": [
        6878
    ],
    "sikkimese": [
        6879
    ],
    "sikami": [
        6879
    ],
    "sikkim bhotia": [
        6879
    ],
    "sikkim": [
        6879
    ],
    "sikkim bhutia": [
        6879
    ],
    "sikkimese bhutia": [
        6879
    ],
    "sonia": [
        6880
    ],
    "siri": [
        6881,
        7232
    ],
    "sirawa": [
        6881
    ],
    "siuslaw": [
        6882
    ],
    "siuslawan": [
        6882
    ],
    "sinagen": [
        6883
    ],
    "sumariup": [
        6884
    ],
    "smajof": [
        6884
    ],
    "sogoba": [
        6884
    ],
    "sohoba": [
        6884
    ],
    "siuai": [
        6885
    ],
    "sumau": [
        6886
    ],
    "sumau-garia": [
        6886
    ],
    "sivandi": [
        6887
    ],
    "siwi": [
        6888
    ],
    "sioua": [
        6888
    ],
    "siwa": [
        6888
    ],
    "siwaan": [
        6888
    ],
    "saija": [
        6889
    ],
    "siapedie": [
        6889
    ],
    "southern embera": [
        6889
    ],
    "southern empera": [
        6889
    ],
    "southern epena": [
        6889
    ],
    "sajau basap": [
        6890
    ],
    "sajau": [
        6890
    ],
    "sujau": [
        6890
    ],
    "saami, kildin": [
        6891
    ],
    "saami, pite": [
        6892
    ],
    "soungor": [
        6893
    ],
    "sungor": [
        6893
    ],
    "sajalong": [
        6895
    ],
    "sajolang": [
        6895
    ],
    "sulu": [
        6896,
        7734,
        7735
    ],
    "sama mapun": [
        6896
    ],
    "sindarin": [
        6897,
        6898
    ],
    "sibin": [
        6899,
        6900,
        6901,
        6902
    ],
    "surjapuri": [
        6903,
        6904
    ],
    "sura": [
        6903,
        6904,
        7109,
        7198,
        7321
    ],
    "siar-lak": [
        6905
    ],
    "senhaja berber": [
        6906
    ],
    "senhaja": [
        6906
    ],
    "senhaja de srair": [
        6906
    ],
    "srair": [
        6906
    ],
    "senhajiya": [
        6906
    ],
    "shilha barbarya": [
        6906
    ],
    "shilha n jbala": [
        6906
    ],
    "saami, ter": [
        6907
    ],
    "saami, ume": [
        6908
    ],
    "shawnee": [
        6909
    ],
    "savannah": [
        6909
    ],
    "sewanee": [
        6909
    ],
    "shawano": [
        6909
    ],
    "slovak": [
        6910,
        6911,
        7219
    ],
    "slovenčina": [
        6910,
        6911
    ],
    "slovakian": [
        7219,
        6910,
        6911
    ],
    "slovenský jazyk": [
        6910,
        6911
    ],
    "slovenský": [
        6910,
        6911
    ],
    "skagit": [
        6912
    ],
    "swinomish": [
        6912
    ],
    "saek": [
        6913,
        8804
    ],
    "seak": [
        6913
    ],
    "set": [
        6913
    ],
    "sauk": [
        6914
    ],
    "san raphael": [
        6915
    ],
    "southern sierra miwok": [
        6915
    ],
    "seke": [
        6916,
        6921,
        7269
    ],
    "seke (vanuatu)": [
        6916
    ],
    "ske": [
        6916
    ],
    "sakirabiá": [
        6917
    ],
    "sakirabiák": [
        6917
    ],
    "sakirabiáp": [
        6917
    ],
    "sakirabiát": [
        6917
    ],
    "sakirap": [
        6917
    ],
    "sakiriabar": [
        6917
    ],
    "sakurabiat": [
        6917
    ],
    "sakalava malagasy": [
        6918
    ],
    "sikule": [
        6919
    ],
    "sichule": [
        6919
    ],
    "sigulai": [
        6919
    ],
    "sikhule": [
        6919
    ],
    "simeulue barat": [
        6919
    ],
    "simeulue": [
        6979,
        6919
    ],
    "sika": [
        6920
    ],
    "sara sikka": [
        6920
    ],
    "sikka": [
        6920
    ],
    "sikkanese": [
        6920
    ],
    "seke (nepal)": [
        6921
    ],
    "sakam": [
        6922
    ],
    "subanon, kolibugan": [
        6923
    ],
    "subanon": [
        6923,
        7189,
        7159
    ],
    "seko tengah": [
        6924
    ],
    "seko": [
        6924,
        6936
    ],
    "sekapan": [
        6925
    ],
    "sekepan": [
        6925
    ],
    "sininkere": [
        6926
    ],
    "silanke": [
        6926
    ],
    "silinkere": [
        6926
    ],
    "saraiki": [
        6927,
        6928,
        6929,
        6930
    ],
    "seraiki": [
        6927,
        6928,
        6929,
        6930
    ],
    "siraiki": [
        6927,
        6928,
        6929,
        6930
    ],
    "saki": [
        6931
    ],
    "suaro": [
        6931
    ],
    "sakata": [
        6932
    ],
    "sakao": [
        6933
    ],
    "sakau": [
        6933
    ],
    "skou": [
        6934
    ],
    "sekol": [
        6934
    ],
    "sekou": [
        6934
    ],
    "sko": [
        6934
    ],
    "skouw": [
        6934
    ],
    "skow": [
        6934
    ],
    "sukou": [
        6934
    ],
    "skepi dutch creole": [
        6935
    ],
    "skepi": [
        6935
    ],
    "skepi creole dutch": [
        6935
    ],
    "seko padang": [
        6936
    ],
    "sua tu padang": [
        6936
    ],
    "sikaiana": [
        6937
    ],
    "sikayana": [
        6937
    ],
    "sekar": [
        6938
    ],
    "slovene": [
        6939,
        6940,
        8906
    ],
    "slovenščina": [
        6939,
        6940
    ],
    "slovenian": [
        6939,
        6940,
        8906
    ],
    "slovenski jezik": [
        6939,
        6940
    ],
    "slovenski": [
        6939,
        6940,
        8906
    ],
    "sáliba": [
        6941
    ],
    "sáliva": [
        6941
    ],
    "sissala": [
        6942
    ],
    "sɩ́ssalɩ́": [
        6942
    ],
    "sisaali": [
        6942
    ],
    "sɩsaala": [
        6942
    ],
    "sholaga": [
        6943
    ],
    "sholigar": [
        6943
    ],
    "sholanayika": [
        6943
    ],
    "sholiga": [
        6943
    ],
    "solaga": [
        6943
    ],
    "solagaru mattu": [
        6943
    ],
    "solagaru": [
        6943
    ],
    "solanayakkans": [
        6943
    ],
    "solega": [
        6943
    ],
    "soliga": [
        6943
    ],
    "soligar": [
        6943
    ],
    "swiss-italian sign language": [
        6944
    ],
    "swiss-italian": [
        6944
    ],
    "svizzera": [
        6944
    ],
    "selungai": [
        6945
    ],
    "selungai murut": [
        6945
    ],
    "southern lushootseed": [
        6946
    ],
    "southern puget sound salish": [
        6946
    ],
    "silesian, lower": [
        6947
    ],
    "silesian": [
        6947,
        7288
    ],
    "schlesisch": [
        6947
    ],
    "schlesische sprache": [
        6947
    ],
    "schlesische": [
        6947
    ],
    "schläsche sproache": [
        6947
    ],
    "schläsche": [
        6947
    ],
    "sproache": [
        6947
    ],
    "silesian german": [
        6947
    ],
    "salumá": [
        6948
    ],
    "salt-iui": [
        6949
    ],
    "salt-yui": [
        6949
    ],
    "sama, pangutaran": [
        6950
    ],
    "siyama pangutaran": [
        6950
    ],
    "siyama": [
        6950
    ],
    "sama pangutaran": [
        6950
    ],
    "salinan": [
        6951
    ],
    "solor": [
        6952
    ],
    "solorese": [
        6952
    ],
    "salchuq": [
        6953
    ],
    "seljuq": [
        6953
    ],
    "seljūq": [
        6953
    ],
    "salar": [
        6954
    ],
    "singapore sign language": [
        6955
    ],
    "sgsl": [
        6955
    ],
    "selaru": [
        6957
    ],
    "salaru": [
        6957
    ],
    "sialum": [
        6958
    ],
    "salampasu": [
        6959
    ],
    "selayar": [
        6960
    ],
    "salajar": [
        6960
    ],
    "salayar": [
        6960
    ],
    "salayer": [
        6960
    ],
    "saleier": [
        6960
    ],
    "siladja": [
        6960
    ],
    "silajara": [
        6960
    ],
    "sailolof": [
        6961
    ],
    "salawati": [
        8553,
        6961
    ],
    "samate": [
        6961
    ],
    "samoan": [
        6962
    ],
    "saami, south": [
        6963
    ],
    "southern lapp": [
        6963
    ],
    "southern sami": [
        6963
    ],
    "simbari": [
        6964
    ],
    "som": [
        6965,
        8149,
        9155
    ],
    "somm": [
        6965
    ],
    "simog": [
        6967
    ],
    "simbali": [
        6968
    ],
    "samei": [
        6969
    ],
    "saami, lule": [
        6970
    ],
    "sambal bolinao": [
        6971
    ],
    "sama, central": [
        6972
    ],
    "sinama": [
        6972,
        7129,
        7143,
        7132,
        7133
    ],
    "sama dilaut": [
        6972
    ],
    "sama kabinga’an": [
        6972
    ],
    "sama mandelaut": [
        6972
    ],
    "sama pala’u": [
        6972
    ],
    "sama siasi": [
        6972
    ],
    "sama sitangkai": [
        6972
    ],
    "sitangkai": [
        6972
    ],
    "sama ubian": [
        6972
    ],
    "samal": [
        6972,
        7132,
        7133
    ],
    "saami, inari": [
        6974
    ],
    "samaritan hebrew": [
        6976,
        6977,
        6975
    ],
    "samon": [
        6978
    ],
    "supei": [
        6978
    ],
    "simalur": [
        6979
    ],
    "simeuloë": [
        6979
    ],
    "simulul": [
        6979
    ],
    "saami, skolt": [
        6980,
        6981
    ],
    "skolt": [
        6980,
        6981
    ],
    "skolt sami": [
        6980,
        6981
    ],
    "sääʹmǩiõll": [
        6980,
        6981
    ],
    "simte": [
        6982
    ],
    "somray": [
        6983,
        7041
    ],
    "samvedi": [
        6984
    ],
    "sumbawa": [
        6985
    ],
    "semawa": [
        6985
    ],
    "sumbawarese": [
        6985
    ],
    "saamba": [
        6986
    ],
    "shankadi": [
        6986
    ],
    "semnani": [
        6987
    ],
    "simnani": [
        6987
    ],
    "simeku": [
        6988
    ],
    "sebuyau": [
        6991
    ],
    "sabuyan": [
        6991
    ],
    "sabuyau": [
        6991
    ],
    "sibuian": [
        6991
    ],
    "sibuyan": [
        6991
    ],
    "sibuyau": [
        6991
    ],
    "sinaugoro": [
        6992
    ],
    "sinagoro": [
        6992
    ],
    "sarawak dayak": [
        6993
    ],
    "sarawak": [
        6993
    ],
    "serer-noon": [
        6994
    ],
    "sanga (democratic republic of congo)": [
        6995,
        6996
    ],
    "southern luba": [
        6995,
        6996
    ],
    "shinabo": [
        6997
    ],
    "sensi": [
        6998
    ],
    "senti": [
        6998
    ],
    "sango, riverain": [
        6999
    ],
    "soninke": [
        7000,
        7001
    ],
    "sooninkanxanne": [
        7000,
        7001
    ],
    "sarakole": [
        7000,
        7001
    ],
    "sarakolle": [
        7000,
        7001
    ],
    "sarakolé": [
        7000
    ],
    "sarakule": [
        7000,
        7001
    ],
    "sarakulle": [
        7000,
        7001
    ],
    "sarangkole": [
        7000,
        7001
    ],
    "sarangkolle": [
        7000,
        7001
    ],
    "saraxuli": [
        7000,
        7001
    ],
    "sebbe": [
        7000,
        7001
    ],
    "serahule": [
        7000,
        7001
    ],
    "serecole": [
        7000,
        7001
    ],
    "soninkanxanne": [
        7000,
        7001
    ],
    "sooninke": [
        7000,
        7001
    ],
    "sangil": [
        7002
    ],
    "sanggil": [
        7002
    ],
    "sangihé": [
        7002,
        7260
    ],
    "sangirese": [
        7002,
        7260
    ],
    "sangiré": [
        7002
    ],
    "southern ma'di": [
        7003
    ],
    "siona": [
        7004
    ],
    "sioni": [
        7004
    ],
    "snohomish": [
        7005
    ],
    "siane": [
        7006,
        7007
    ],
    "siani": [
        7006,
        7007
    ],
    "siyane": [
        7006,
        7007
    ],
    "sangu (gabon)": [
        7008
    ],
    "shango": [
        7008
    ],
    "sihan": [
        7009,
        7053
    ],
    "seniang": [
        7010
    ],
    "sinesip": [
        7010
    ],
    "south west bay": [
        7010
    ],
    "senggi": [
        7011
    ],
    "sa’ban": [
        7012
    ],
    "sa'ban": [
        7012
    ],
    "selee": [
        7013
    ],
    "santrokofi": [
        7013
    ],
    "sele": [
        7013
    ],
    "sentrokofi": [
        7013
    ],
    "songum": [
        7014
    ],
    "songumsam": [
        7014
    ],
    "saniyo-hiyewe": [
        7015
    ],
    "sanio-hiowe": [
        7015
    ],
    "sensauru": [
        7016
    ],
    "sinsauru": [
        7016
    ],
    "somali": [
        7017,
        7018,
        7019,
        7020,
        7021,
        7022
    ],
    "soomaali": [
        7017,
        7018,
        7019,
        7020,
        7021
    ],
    "soomaaliga": [
        7017,
        7018,
        7022
    ],
    "standard somali": [
        7017,
        7018,
        7022
    ],
    "song": [
        7023,
        7024
    ],
    "soang": [
        7023,
        7024
    ],
    "so (democratic republic of congo)": [
        7026
    ],
    "soa": [
        7026,
        7145
    ],
    "soko": [
        7026
    ],
    "songoora": [
        7027
    ],
    "songomeno": [
        7028
    ],
    "sogdian": [
        7029,
        7030,
        7031,
        7032
    ],
    "silak": [
        7033
    ],
    "sillok": [
        7033
    ],
    "sonha": [
        7034
    ],
    "sonaha": [
        7034
    ],
    "sonahaa": [
        7034
    ],
    "sunah": [
        7034
    ],
    "sunha": [
        7034
    ],
    "soi": [
        7035
    ],
    "sokoro": [
        7036
    ],
    "soŋoroŋ": [
        7036
    ],
    "solos": [
        7037
    ],
    "sumoun": [
        7037
    ],
    "songe": [
        7039
    ],
    "songye": [
        7039
    ],
    "somrai": [
        7041
    ],
    "shibne": [
        7041
    ],
    "sibine": [
        7041
    ],
    "somre": [
        7041
    ],
    "somrei": [
        7041
    ],
    "soumrai": [
        7041
    ],
    "soumray": [
        7041
    ],
    "soumraye": [
        7041
    ],
    "sounrai": [
        7041
    ],
    "sumrai": [
        7041
    ],
    "seeku": [
        7042
    ],
    "sambla": [
        7042
    ],
    "seenku": [
        7042
    ],
    "sembla": [
        7042
    ],
    "southern thai": [
        7043
    ],
    "sonsorolese": [
        7044
    ],
    "sonsorol": [
        7044
    ],
    "sonsorol-tobi": [
        7044
    ],
    "sowanda": [
        7045
    ],
    "swo": [
        7046
    ],
    "shwo": [
        7046
    ],
    "sso": [
        7046
    ],
    "sô": [
        7046,
        7147,
        7148
    ],
    "solamba": [
        7047
    ],
    "solla": [
        7047
    ],
    "sorouba": [
        7047
    ],
    "soruba": [
        7047
    ],
    "sonjo": [
        7048
    ],
    "sonyo": [
        7048
    ],
    "sepa (indonesia)": [
        7049
    ],
    "sapé": [
        7050
    ],
    "saep": [
        7051
    ],
    "sepa (papua new guinea)": [
        7052
    ],
    "sian": [
        7053
    ],
    "saponi": [
        7054
    ],
    "sengo": [
        7055
    ],
    "selepet": [
        7056
    ],
    "selepe": [
        7056
    ],
    "sepen": [
        7057
    ],
    "sanapaná": [
        7058
    ],
    "saapa’ang": [
        7058
    ],
    "sa’apan": [
        7058
    ],
    "spokane": [
        7059
    ],
    "spokan": [
        7059
    ],
    "sénoufo, supyire": [
        7060
    ],
    "supyire": [
        7060
    ],
    "suppire": [
        7060
    ],
    "supyire senoufo": [
        7060
    ],
    "sup’ide": [
        7060
    ],
    "spanish, charapa": [
        7061
    ],
    "sharapa": [
        7061
    ],
    "saparua": [
        7062
    ],
    "saposa": [
        7063
    ],
    "spiti bhoti": [
        7064
    ],
    "spiti": [
        7064
    ],
    "sapuan": [
        7065
    ],
    "sapouan": [
        7065
    ],
    "sambalpuri": [
        7066
    ],
    "south picene": [
        7067
    ],
    "shkip": [
        7068,
        7070,
        7071
    ],
    "skchip": [
        7068,
        7070,
        7071
    ],
    "shama-sambuga": [
        7075
    ],
    "shau": [
        7076
    ],
    "shenjave": [
        7077
    ],
    "shqiq": [
        7077
    ],
    "shqipe": [
        7077
    ],
    "souma": [
        7078
    ],
    "susquehannock": [
        7079
    ],
    "sorkhei": [
        7080
    ],
    "sawk": [
        7081
    ],
    "souk": [
        7081
    ],
    "su": [
        7081,
        7293
    ],
    "suq": [
        7081
    ],
    "su’": [
        7081
    ],
    "siculo arabic": [
        7082
    ],
    "siculo": [
        7082
    ],
    "sri lankan sign language": [
        7083
    ],
    "soqotri": [
        7084,
        7085
    ],
    "saqatri": [
        7084,
        7085
    ],
    "socotri": [
        7084,
        7085
    ],
    "sokotri": [
        7084,
        7085
    ],
    "suqutri": [
        7084,
        7085
    ],
    "squamish": [
        7086
    ],
    "skwxwu’mesh snichim": [
        7086
    ],
    "skwxwu’mesh": [
        7086
    ],
    "snichim": [
        7086
    ],
    "serbian": [
        7088,
        7089,
        7090,
        7091,
        7092,
        7093,
        7094,
        7095,
        7096,
        7097,
        7098,
        7099,
        8906
    ],
    "srpski": [
        7092,
        7093,
        7094,
        7095,
        8906
    ],
    "saruga": [
        7100
    ],
    "sora": [
        7101,
        7102,
        7103,
        7104
    ],
    "sabara": [
        7101,
        7102,
        7103,
        7104
    ],
    "saonras": [
        7101,
        7102,
        7103,
        7104
    ],
    "saora": [
        7101,
        7102,
        7103,
        7104
    ],
    "saura": [
        7101,
        7102,
        7103,
        7104
    ],
    "savara": [
        7101,
        7102,
        7103,
        7104
    ],
    "sawaria": [
        7101,
        7102,
        7103,
        7104
    ],
    "shabari": [
        7101,
        7102,
        7103,
        7104
    ],
    "soura": [
        7101,
        7102,
        7103,
        7104
    ],
    "swara": [
        7101,
        7102,
        7103,
        7104
    ],
    "sirak": [
        7106
    ],
    "sulod": [
        7107
    ],
    "sarikoli": [
        7108
    ],
    "salikur": [
        7108
    ],
    "saliku’er": [
        7108
    ],
    "sarikuli": [
        7108
    ],
    "sariqul": [
        7108
    ],
    "sarykoly": [
        7108
    ],
    "siriano": [
        7109
    ],
    "sarirá": [
        7109
    ],
    "si-ra": [
        7109
    ],
    "siria-masã": [
        7109
    ],
    "siriana": [
        7109
    ],
    "siriane": [
        7109
    ],
    "sura masa": [
        7109
    ],
    "surianá": [
        7109
    ],
    "surirá": [
        7109
    ],
    "suryana": [
        7109
    ],
    "serudung": [
        7110
    ],
    "serudong": [
        7110
    ],
    "serudung murut": [
        7110
    ],
    "suudung": [
        7110
    ],
    "saberi": [
        7111
    ],
    "saweri": [
        7111
    ],
    "saramaccan": [
        7112
    ],
    "saamáka": [
        7112
    ],
    "saramaccaans": [
        7112
    ],
    "sranan tongo": [
        7113
    ],
    "sranan": [
        7113
    ],
    "suriname creole english": [
        7113
    ],
    "surinamese": [
        7113
    ],
    "sardinian, campidanese": [
        7114
    ],
    "sardu": [
        7114
    ],
    "south sardinian": [
        7114
    ],
    "sirionó": [
        7115
    ],
    "serer-sine": [
        7116,
        7117
    ],
    "seereer": [
        7116,
        7117
    ],
    "seex": [
        7116,
        7117
    ],
    "serer-sin": [
        7116,
        7117
    ],
    "serrer": [
        7116,
        7117
    ],
    "sine-saloum": [
        7116,
        7117
    ],
    "sine-sine": [
        7116,
        7117
    ],
    "sérère-sine": [
        7116,
        7117
    ],
    "sarsi": [
        7118
    ],
    "sarcee": [
        7118
    ],
    "sauri": [
        7119
    ],
    "suruí de rondônia": [
        7120
    ],
    "suruí do jiparaná": [
        7120
    ],
    "suruí-paiter": [
        7120
    ],
    "sorsoganon, southern": [
        7121
    ],
    "southern sorsoganon": [
        7121
    ],
    "southern sorsogon": [
        7121
    ],
    "serua": [
        7122
    ],
    "sirmauri": [
        7123,
        7124
    ],
    "sirmouri": [
        7123,
        7124
    ],
    "sirmuri": [
        7123,
        7124
    ],
    "sera": [
        7125
    ],
    "ser": [
        7125
    ],
    "serra": [
        7125
    ],
    "ssia": [
        7125
    ],
    "shahmirzadi": [
        7126
    ],
    "swati": [
        7127,
        7128
    ],
    "siswati": [
        7127,
        7128
    ],
    "sephuthi": [
        7127
    ],
    "siswazi": [
        7127
    ],
    "swazi": [
        7127
    ],
    "síphùthì": [
        7127
    ],
    "sama, southern": [
        7129
    ],
    "sama tawi-tawi": [
        7129
    ],
    "sinama tawi-tawi": [
        7129
    ],
    "southern bajau": [
        7129
    ],
    "southern sama": [
        7129
    ],
    "southern sinama": [
        7129
    ],
    "suba-simbiti": [
        7130
    ],
    "simbiti": [
        7130
    ],
    "siroi": [
        7131
    ],
    "suroi": [
        7131
    ],
    "sama, balangingih": [
        7132,
        7133
    ],
    "sama baangingi": [
        7132,
        7133
    ],
    "sama bangingih": [
        7132,
        7133
    ],
    "sinama baangingi": [
        7132,
        7133
    ],
    "shao": [
        7134
    ],
    "suihwan": [
        7134
    ],
    "seimat": [
        7135
    ],
    "shihhi": [
        7136
    ],
    "shihhi arabic": [
        7136
    ],
    "shihu": [
        7136
    ],
    "shihuh": [
        7136
    ],
    "sansi": [
        7137
    ],
    "sansiboli": [
        7137
    ],
    "sausi": [
        7138
    ],
    "sunam": [
        7139
    ],
    "sangnaur": [
        7139
    ],
    "sungam": [
        7139
    ],
    "sungnam": [
        7139
    ],
    "sunnam": [
        7139
    ],
    "sisaala, western": [
        7140
    ],
    "semnam": [
        7141
    ],
    "sinano": [
        7143
    ],
    "sisano": [
        7143
    ],
    "sissano": [
        7143
    ],
    "spanish sign language": [
        7144
    ],
    "so’a": [
        7145
    ],
    "so'a": [
        7145
    ],
    "swiss-french sign language": [
        7146
    ],
    "swiss-french": [
        7146
    ],
    "so makon": [
        7147,
        7148
    ],
    "sinasina": [
        7149
    ],
    "susuami": [
        7150
    ],
    "shark bay": [
        7151
    ],
    "shark": [
        7151
    ],
    "samberigi": [
        7152
    ],
    "sambeleke": [
        7152
    ],
    "sanaberigi": [
        7152
    ],
    "saho": [
        7153,
        7154
    ],
    "shaho": [
        7153
    ],
    "shiho": [
        7153
    ],
    "shoho": [
        7153
    ],
    "sengseng": [
        7155
    ],
    "sotho, southern": [
        7156
    ],
    "sisutho": [
        7156
    ],
    "southern sotho": [
        7157,
        7156
    ],
    "souto": [
        7156
    ],
    "suthu": [
        7156
    ],
    "suto": [
        7156
    ],
    "settla": [
        7158
    ],
    "subanen, northern": [
        7159
    ],
    "subaanen": [
        7267,
        7159
    ],
    "sentinel": [
        7160
    ],
    "sentinelese": [
        7160
    ],
    "seta": [
        7162,
        8458
    ],
    "strieng": [
        7163
    ],
    "shelta": [
        7164
    ],
    "sheldru": [
        7164
    ],
    "shelter": [
        7164
    ],
    "shelterorch": [
        7164
    ],
    "stieng, bulo": [
        7165,
        7166
    ],
    "stieng": [
        7165,
        7166,
        7177
    ],
    "samo, matya": [
        7167
    ],
    "sànán": [
        7167
    ],
    "sã": [
        7167
    ],
    "serki": [
        7168
    ],
    "serkisetavi": [
        7168
    ],
    "stellingwerfs": [
        7169
    ],
    "stellingwarfs": [
        7169
    ],
    "stellingwerf": [
        7169
    ],
    "setaman": [
        7170
    ],
    "santa anna": [
        7171
    ],
    "stoney": [
        7172
    ],
    "stony": [
        7172
    ],
    "southeastern tepehuan": [
        7173
    ],
    "saterfriesisch": [
        7174
    ],
    "saterfriesen": [
        7174
    ],
    "saterfriesiesch": [
        7174
    ],
    "saterlandic": [
        7174
    ],
    "saterlandic frisian": [
        7174
    ],
    "saterländisch": [
        7174
    ],
    "seeltersk": [
        7174
    ],
    "salish, straits": [
        7175
    ],
    "senćoŧen": [
        7175
    ],
    "straits salish": [
        7175
    ],
    "shumashti": [
        7176
    ],
    "shumasht": [
        7176
    ],
    "stieng, budeh": [
        7177
    ],
    "southern stieng": [
        7177
    ],
    "samtao": [
        7178,
        8504
    ],
    "samtau": [
        7178
    ],
    "samtuan": [
        7178
    ],
    "silt’e": [
        7179,
        7180
    ],
    "silt'e": [
        7179,
        7180
    ],
    "satawalese": [
        7181
    ],
    "satawal": [
        7181
    ],
    "siberian tatar": [
        7182
    ],
    "seber": [
        7182
    ],
    "sebertatar": [
        7182
    ],
    "siberian turkish": [
        7182
    ],
    "sybyr": [
        7182
    ],
    "sulka": [
        7187
    ],
    "suku": [
        7188
    ],
    "subanon, western": [
        7189
    ],
    "siocon": [
        7189
    ],
    "suena": [
        7190
    ],
    "suganga": [
        7191
    ],
    "suki": [
        7192,
        8182
    ],
    "shubi": [
        7193
    ],
    "shuwi": [
        7193
    ],
    "sinja": [
        7193
    ],
    "sinya": [
        7193,
        7278
    ],
    "subi": [
        7193
    ],
    "sukuma": [
        7194
    ],
    "sumo": [
        7195
    ],
    "suri, tirmaga-chai": [
        7196,
        7197
    ],
    "surichɛn": [
        7196,
        7197
    ],
    "susu": [
        7199,
        7200
    ],
    "sosoxui": [
        7199,
        7200
    ],
    "sose": [
        7199,
        7200
    ],
    "soso": [
        7199,
        7200
    ],
    "soussou": [
        7199,
        7200
    ],
    "susoo": [
        7199,
        7200
    ],
    "subtiaba": [
        7201
    ],
    "subtiava": [
        7201
    ],
    "sumbwa": [
        7205
    ],
    "shisumbwa": [
        7205
    ],
    "shumbwa": [
        7205
    ],
    "sumerian": [
        7206
    ],
    "suyá": [
        7207
    ],
    "suiá": [
        7207
    ],
    "sunwar": [
        7208
    ],
    "sunuwar": [
        7208
    ],
    "sunwari": [
        7208
    ],
    "svenska": [
        7209,
        7210,
        7212,
        7211
    ],
    "sverige": [
        7209
    ],
    "svan": [
        7213,
        7214,
        7215
    ],
    "svanuri": [
        7213,
        7214,
        7215
    ],
    "suain": [
        7216
    ],
    "serili": [
        7218
    ],
    "slovakian sign language": [
        7219
    ],
    "slovak republic sign language": [
        7219
    ],
    "slovak sign language": [
        7219
    ],
    "slovnik posunkovej reci": [
        7219
    ],
    "slovnik": [
        7219
    ],
    "slovník posunkovej reči": [
        7219
    ],
    "slovník": [
        7219
    ],
    "slavomolisano": [
        7220
    ],
    "slavic of molise": [
        7220
    ],
    "savosavo": [
        7221
    ],
    "savo": [
        7221
    ],
    "savo island": [
        7221
    ],
    "skalvian": [
        7222
    ],
    "swahili (macrolanguage)": [
        7223,
        7224,
        7225,
        7226,
        7227
    ],
    "suahili": [
        7223,
        7234,
        7235
    ],
    "shimaore": [
        7228,
        7229
    ],
    "swahili, congo": [
        7230,
        7231
    ],
    "sere": [
        7232
    ],
    "serre": [
        7232
    ],
    "shaire": [
        7232
    ],
    "shere": [
        7232
    ],
    "sheri": [
        7232
    ],
    "sili": [
        7232
    ],
    "swabian": [
        7233
    ],
    "schwaebisch": [
        7233
    ],
    "schwäbisch": [
        7233
    ],
    "suabian": [
        7233
    ],
    "swahili (individual language)": [
        7234,
        7235
    ],
    "sui li": [
        7236
    ],
    "suipo": [
        7236
    ],
    "shira": [
        7237,
        8941
    ],
    "shire": [
        7237
    ],
    "sena, malawi": [
        7238
    ],
    "swedish sign language": [
        7239
    ],
    "sts": [
        7239
    ],
    "svenskt teckenspråk": [
        7239
    ],
    "svenskt": [
        7239
    ],
    "swedsl": [
        7239
    ],
    "samosa": [
        7240
    ],
    "sawknah": [
        7241
    ],
    "sokna": [
        7241
    ],
    "sokni": [
        7241
    ],
    "sukna": [
        7241
    ],
    "shanenawa": [
        7242
    ],
    "shanenawá": [
        7242
    ],
    "suau": [
        7243
    ],
    "suwau": [
        7243
    ],
    "sharwa": [
        7244
    ],
    "sarwaye": [
        7244
    ],
    "sherwin": [
        7244
    ],
    "saweru": [
        7245
    ],
    "sarwar use": [
        7245
    ],
    "sarwar": [
        7245
    ],
    "seluwasan": [
        7246
    ],
    "selvasa": [
        7246
    ],
    "selwasa": [
        7246
    ],
    "sawila": [
        7247
    ],
    "sawali": [
        7247
    ],
    "suwawa": [
        7248
    ],
    "suvava": [
        7248
    ],
    "shekhawati": [
        7249
    ],
    "shekhawati-marwari": [
        7249
    ],
    "sowa": [
        7250
    ],
    "suruahá": [
        7251
    ],
    "sorowaha": [
        7251
    ],
    "suruwahá": [
        7251
    ],
    "sarua": [
        7252
    ],
    "saroua": [
        7252
    ],
    "sarwa": [
        7252
    ],
    "suba": [
        7253
    ],
    "sicanian": [
        7254
    ],
    "sighu": [
        7255
    ],
    "sigu": [
        7255
    ],
    "shuhi": [
        7256
    ],
    "shixing": [
        7256
    ],
    "southern kalapuya": [
        7257
    ],
    "selian": [
        7258
    ],
    "samre": [
        7259
    ],
    "sangir": [
        7260
    ],
    "sangih": [
        7260
    ],
    "sangihẹ̆": [
        7260
    ],
    "sorothaptic": [
        7261
    ],
    "saaroa": [
        7262
    ],
    "saarua": [
        7262
    ],
    "saroa": [
        7262
    ],
    "shishaban": [
        7262
    ],
    "sisyaban": [
        7262
    ],
    "sasaru": [
        7263
    ],
    "saxon, upper": [
        7264
    ],
    "sächsisch": [
        7264
    ],
    "saxwe": [
        7265
    ],
    "saxwɛgbe": [
        7265
    ],
    "sahouè": [
        7265
    ],
    "sahouègbe": [
        7265
    ],
    "saxwe gbe": [
        7265
    ],
    "saxwe-gbe": [
        7265
    ],
    "saxwegbe": [
        7265
    ],
    "saxwɛ": [
        7265
    ],
    "siang": [
        7266
    ],
    "subanen, central": [
        7267
    ],
    "sinubaanen": [
        7267
    ],
    "sindangan subanun": [
        7267
    ],
    "sindangan": [
        7267
    ],
    "syriac": [
        7268,
        7277
    ],
    "syriac aramaic": [
        7268
    ],
    "syrian aramaic": [
        7268
    ],
    "syro-aramaic": [
        7268
    ],
    "seki": [
        7269
    ],
    "sekiana": [
        7269
    ],
    "sekiani": [
        7269
    ],
    "sekiyani": [
        7269
    ],
    "sekyani": [
        7269
    ],
    "seseki": [
        7269
    ],
    "sheke": [
        7269
    ],
    "shekiyana": [
        7269
    ],
    "sukur": [
        7270
    ],
    "sakul": [
        7270
    ],
    "sugur": [
        7270
    ],
    "sylheti": [
        7271,
        7272,
        7273
    ],
    "sileti": [
        7272,
        7271,
        7273
    ],
    "siloti": [
        7271,
        7272,
        7273
    ],
    "srihattia": [
        7271,
        7272,
        7273
    ],
    "sylheti bangla": [
        7271,
        7272,
        7273
    ],
    "sylheti bengali": [
        7271,
        7272,
        7273
    ],
    "sylhetti": [
        7271,
        7272,
        7273
    ],
    "sylhetti bangla": [
        7271,
        7272,
        7273
    ],
    "syloti": [
        7271,
        7272,
        7273
    ],
    "syloty": [
        7271,
        7272,
        7273
    ],
    "samo, maya": [
        7274
    ],
    "senaya": [
        7275
    ],
    "sray": [
        7275
    ],
    "senaaya": [
        7275
    ],
    "shan gyanan": [
        7275
    ],
    "shan sray": [
        7275
    ],
    "soray": [
        7275
    ],
    "su’ung": [
        7276
    ],
    "soorath": [
        7277
    ],
    "soorith": [
        7277
    ],
    "suras": [
        7277
    ],
    "sinyar": [
        7278
    ],
    "shamya": [
        7278
    ],
    "shamyan": [
        7278
    ],
    "shemya": [
        7278
    ],
    "symiarta": [
        7278
    ],
    "syuba": [
        7279
    ],
    "shuba": [
        7279
    ],
    "shuuba": [
        7279
    ],
    "shuva": [
        7279
    ],
    "shyuuba": [
        7279
    ],
    "syuba tam": [
        7279
    ],
    "syuuba": [
        7279
    ],
    "samay": [
        7280
    ],
    "samaye": [
        7280
    ],
    "shamay": [
        7280
    ],
    "shamayi": [
        7280
    ],
    "semelai": [
        7282
    ],
    "sibil": [
        7283
    ],
    "semaq beri": [
        7284
    ],
    "semaq": [
        7284
    ],
    "semaq bri": [
        7284
    ],
    "semoq beri": [
        7284
    ],
    "semoq": [
        7284
    ],
    "seru": [
        7285
    ],
    "seze": [
        7286
    ],
    "sengele": [
        7287
    ],
    "sengere": [
        7287
    ],
    "slonska godka": [
        7288
    ],
    "slonska": [
        7288
    ],
    "szlonzokian": [
        7288
    ],
    "sanana": [
        7289
    ],
    "suabo": [
        7290
    ],
    "suabau": [
        7290
    ],
    "solomon islands sign language": [
        7291,
        7292
    ],
    "sisl": [
        7291,
        7292
    ],
    "subu": [
        7293
    ],
    "sakizaya": [
        7295
    ],
    "sakezhaye": [
        7295
    ],
    "sakidaya": [
        7295
    ],
    "sakiray": [
        7295
    ],
    "sakiraya": [
        7295
    ],
    "sukizaya": [
        7295
    ],
    "sei": [
        7308,
        7309,
        7310
    ],
    "samachique tarahumara": [
        7318
    ],
    "samachique": [
        7318
    ],
    "shabogala": [
        7324,
        7325,
        7326
    ],
    "sambio": [
        7352
    ],
    "soma": [
        7354
    ],
    "some": [
        7354
    ],
    "southern tutchone": [
        7359
    ],
    "sumeri": [
        7366
    ],
    "sumerine": [
        7366
    ],
    "streit": [
        7371
    ],
    "southeastern tarahumara": [
        7373
    ],
    "sawasi": [
        7382,
        7383,
        7384
    ],
    "shant’ou": [
        7386,
        7387
    ],
    "suru": [
        7396
    ],
    "saloema": [
        7397
    ],
    "saluma": [
        7397
    ],
    "sakai": [
        7409
    ],
    "seroq": [
        7409
    ],
    "southern krumen": [
        7412
    ],
    "southwestern kroumen": [
        7412
    ],
    "soo": [
        7428
    ],
    "sert": [
        7435,
        7436
    ],
    "sudest": [
        7456
    ],
    "south santo": [
        7457
    ],
    "shocó": [
        7463
    ],
    "sénoufo, tagwana": [
        7464
    ],
    "siamese": [
        7468,
        7469
    ],
    "standard thai": [
        7468,
        7469
    ],
    "saraka": [
        7475
    ],
    "sharoka": [
        7475
    ],
    "soung": [
        7477
    ],
    "so thavung": [
        7477
    ],
    "sotawueng": [
        7477
    ],
    "saptari": [
        7481
    ],
    "southern tiwa": [
        7517
    ],
    "shan bamar": [
        7524
    ],
    "shan kalee": [
        7524
    ],
    "shan ni": [
        7524
    ],
    "southern tujia": [
        7529
    ],
    "sakhur": [
        7547,
        7548
    ],
    "saxur dili": [
        7547,
        7548
    ],
    "saxur": [
        7547,
        7548
    ],
    "southern tati": [
        7549
    ],
    "southwestern tepehuan": [
        7560
    ],
    "santo domingo totonac": [
        7576
    ],
    "sou nama": [
        7580
    ],
    "silen": [
        7580
    ],
    "sou amana teru": [
        7581
    ],
    "sara toumak": [
        7589
    ],
    "samarokena": [
        7598
    ],
    "samarkena": [
        7598
    ],
    "setswana": [
        7613,
        7614
    ],
    "sechuana": [
        7613
    ],
    "secoana": [
        7613
    ],
    "secwana": [
        7613
    ],
    "southeast tanna": [
        7622
    ],
    "sitongwe": [
        7636
    ],
    "siska": [
        7643
    ],
    "sisya": [
        7643
    ],
    "shengwe": [
        7644
    ],
    "smith river": [
        7647
    ],
    "smith": [
        7647
    ],
    "sierra totonac": [
        7653
    ],
    "sufrai": [
        7664
    ],
    "sahaptin": [
        7686,
        7956,
        8148
    ],
    "springs": [
        7686
    ],
    "scottish cant": [
        7710
    ],
    "scottish traveller cant": [
        7710
    ],
    "snáꞌánj nìꞌ": [
        7716
    ],
    "snáꞌánj": [
        7716
    ],
    "san martín itunyoso trique": [
        7716
    ],
    "san martín itunyoso triqui": [
        7716
    ],
    "sná’ánj nì’": [
        7716
    ],
    "sná’ánj": [
        7716
    ],
    "surayt": [
        7720,
        7721
    ],
    "syryoyo": [
        7720,
        7721
    ],
    "süryani": [
        7720,
        7721
    ],
    "seediq": [
        7722
    ],
    "saediq": [
        7722
    ],
    "sazek": [
        7722
    ],
    "sedek": [
        7722
    ],
    "sedeq": [
        7722
    ],
    "sediakk": [
        7722
    ],
    "sedik": [
        7722
    ],
    "sediq": [
        7722
    ],
    "seedakka": [
        7722
    ],
    "seedek": [
        7722
    ],
    "seedeq": [
        7722
    ],
    "seedik": [
        7722
    ],
    "sejiq": [
        7722
    ],
    "shedekka": [
        7722
    ],
    "shangaan": [
        7727,
        7728
    ],
    "shangana": [
        7727,
        7728
    ],
    "shangani": [
        7727,
        7728
    ],
    "shitsonga": [
        7727,
        7728
    ],
    "sheetshwa": [
        7731
    ],
    "shitshwa": [
        7731
    ],
    "sūg": [
        7734,
        7735
    ],
    "sug": [
        7734,
        7735
    ],
    "sinug": [
        7734,
        7735
    ],
    "sinug tausug": [
        7734,
        7735
    ],
    "sooloo": [
        7734,
        7735
    ],
    "suluk": [
        7734,
        7735
    ],
    "sm’algyax": [
        7737
    ],
    "sangla": [
        7738
    ],
    "sarchapkkha": [
        7738
    ],
    "shachobiikha": [
        7738
    ],
    "shachopkha": [
        7738
    ],
    "sharchagpakha": [
        7738
    ],
    "sharchhokpa": [
        7738
    ],
    "sharchhop": [
        7738
    ],
    "sharchokpa-lo": [
        7738
    ],
    "sharchopkha": [
        7738
    ],
    "songway": [
        7746
    ],
    "songway kiini": [
        7746
    ],
    "salka": [
        7749
    ],
    "selkirk": [
        7767
    ],
    "sikaritai": [
        7779
    ],
    "sikari": [
        7779
    ],
    "saveeng": [
        7783,
        7784,
        7785
    ],
    "sisi": [
        7783,
        7784,
        7785
    ],
    "saveeng-oov": [
        7784
    ],
    "saveeng-tuam": [
        7785
    ],
    "ska:rù:rę’": [
        7798
    ],
    "skarohreh": [
        7798
    ],
    "southeast ambrym": [
        7807
    ],
    "sedoa": [
        7815
    ],
    "skokomish": [
        7818
    ],
    "setswapong": [
        7830
    ],
    "southwestern tarahumara": [
        7833
    ],
    "sungei": [
        7839
    ],
    "soyod": [
        7875
    ],
    "soyon": [
        7875
    ],
    "soyot": [
        7875
    ],
    "santiago atitlán tzutujil": [
        7881,
        7882
    ],
    "san bartolomé venustiano carranza tzotzil": [
        7888,
        7889,
        7890,
        7891
    ],
    "shakoyi": [
        7930
    ],
    "sa-aak": [
        7936
    ],
    "sumu": [
        7955
    ],
    "south mbundu": [
        7957
    ],
    "salumã": [
        7973
    ],
    "shimacu": [
        7992
    ],
    "simacu": [
        7992
    ],
    "sop": [
        8010
    ],
    "southern paiute": [
        8023
    ],
    "southern uzbek": [
        8044
    ],
    "shikarijanam": [
        8045
    ],
    "sekela": [
        8052
    ],
    "sekele": [
        8052
    ],
    "south nyali": [
        8061
    ],
    "southeast babar": [
        8065
    ],
    "southwestern bontok": [
        8066
    ],
    "salavta": [
        8076
    ],
    "shirima": [
        8114
    ],
    "soyaltepec": [
        8117,
        8118
    ],
    "soyaltepec mazatec": [
        8117
    ],
    "soyaltepec mixtec": [
        8118
    ],
    "seto": [
        8136
    ],
    "setu": [
        8136
    ],
    "snabi watubela": [
        8155
    ],
    "snabi": [
        8155
    ],
    "samaran": [
        8165,
        8166
    ],
    "samarenyo": [
        8165,
        8166
    ],
    "samareño": [
        8165,
        8166
    ],
    "samoe": [
        8178
    ],
    "samwé": [
        8178
    ],
    "sux": [
        8186
    ],
    "surara": [
        8194
    ],
    "sumbanese": [
        8215,
        8424
    ],
    "sou upaa": [
        8224
    ],
    "southern toussian": [
        8228
    ],
    "soulátluk": [
        8243
    ],
    "sulátĕlŭk": [
        8243
    ],
    "sarawa": [
        8245
    ],
    "sirzakwai": [
        8245
    ],
    "shimwali": [
        8255
    ],
    "shindzwani": [
        8292,
        8293
    ],
    "sáliba-maco": [
        8322
    ],
    "sanggaixiong": [
        8363
    ],
    "silimo": [
        8364
    ],
    "south ngalik": [
        8364
    ],
    "sambe": [
        8390
    ],
    "shavante": [
        8409
    ],
    "sumba": [
        8424
    ],
    "sumbaasch": [
        8424
    ],
    "sumbaneesch": [
        8424
    ],
    "sumbasch": [
        8424
    ],
    "sherenté": [
        8456
    ],
    "sheta": [
        8458
    ],
    "shinkan": [
        8485
    ],
    "shinkan complex": [
        8485
    ],
    "sinca": [
        8485
    ],
    "szinca": [
        8485
    ],
    "shriana": [
        8486
    ],
    "shipaja": [
        8489
    ],
    "shipaya": [
        8489
    ],
    "southwest ede": [
        8493
    ],
    "saamtaav": [
        8504
    ],
    "samtao ii": [
        8504
    ],
    "shacriaba": [
        8507
    ],
    "shakriabá": [
        8507
    ],
    "shicriaba": [
        8507
    ],
    "shicriabá": [
        8507
    ],
    "sekgalagadi": [
        8511
    ],
    "shekgalagadi": [
        8511
    ],
    "shekgalagari": [
        8511
    ],
    "south maca": [
        8532
    ],
    "saparan": [
        8553
    ],
    "sapran": [
        8553
    ],
    "sutu": [
        8561
    ],
    "sagada igorot": [
        8564
    ],
    "sagada": [
        8564
    ],
    "samalek": [
        8576
    ],
    "soga": [
        8577
    ],
    "shokléng": [
        8579
    ],
    "shukuru": [
        8584
    ],
    "shukurú": [
        8584
    ],
    "southeast tasmanian": [
        8592
    ],
    "sorell": [
        8598
    ],
    "southwestern tasmanian": [
        8610
    ],
    "sabaean": [
        8627
    ],
    "sambalì": [
        8628
    ],
    "sambali": [
        8628
    ],
    "scythian": [
        8629
    ],
    "sidetic": [
        8630
    ],
    "sempan": [
        8631
    ],
    "shamang": [
        8632
    ],
    "samban": [
        8632
    ],
    "sio": [
        8633
    ],
    "sigawa": [
        8633
    ],
    "siâ": [
        8633
    ],
    "sanga (nigeria)": [
        8635
    ],
    "solano": [
        8636
    ],
    "silopi": [
        8637
    ],
    "saaka": [
        8638
    ],
    "saanga": [
        8638
    ],
    "serwa": [
        8639,
        8640
    ],
    "sharpa": [
        8639,
        8640
    ],
    "sherwi tamnye": [
        8639,
        8640
    ],
    "sherwi": [
        8639,
        8640
    ],
    "sharpa bhotia": [
        8640
    ],
    "sanumá": [
        8642
    ],
    "samatali": [
        8642
    ],
    "samatari": [
        8642
    ],
    "sanema": [
        8642
    ],
    "sanima": [
        8642
    ],
    "sanma": [
        8642
    ],
    "sanïma": [
        8642
    ],
    "sanöma": [
        8642
    ],
    "sanɨma": [
        8642
    ],
    "sánuma": [
        8642
    ],
    "sánïma": [
        8642
    ],
    "sudovian": [
        8643
    ],
    "saisiyat": [
        8644
    ],
    "saiset": [
        8644
    ],
    "saisett": [
        8644
    ],
    "saisiat": [
        8644
    ],
    "saisiett": [
        8644
    ],
    "saisirat": [
        8644
    ],
    "saisyet": [
        8644
    ],
    "saisyett": [
        8644
    ],
    "saixia": [
        8644
    ],
    "saysiyat": [
        8644
    ],
    "seisirat": [
        8644
    ],
    "sinicahua": [
        8652
    ],
    "sinicahua mixtec": [
        8652
    ],
    "san juan teita mixtec": [
        8653
    ],
    "sa'an ñuu savi": [
        8655
    ],
    "saan": [
        8655
    ],
    "sa’an ñuu savi": [
        8655
    ],
    "sa’an": [
        8655,
        8656
    ],
    "saꞌan savi": [
        8656
    ],
    "saꞌan": [
        8656
    ],
    "sa’an nda’u": [
        8656
    ],
    "sa’an savi": [
        8656
    ],
    "san miguel piedras mixtec": [
        8658
    ],
    "sindihui": [
        8662
    ],
    "sindihui mixtec": [
        8662
    ],
    "shola nayakan": [
        8675
    ],
    "shola": [
        8675
    ],
    "schekere": [
        8684
    ],
    "shekhani": [
        8686
    ],
    "soghdi": [
        8726
    ],
    "swe’nga": [
        8731
    ],
    "sari yogur": [
        8748,
        8749
    ],
    "sarig": [
        8748,
        8749
    ],
    "sary-uighur": [
        8748,
        8749
    ],
    "sarygh uygur": [
        8748,
        8749
    ],
    "sarygh": [
        8748,
        8749
    ],
    "seyei": [
        8780
    ],
    "seyeyi": [
        8780
    ],
    "shiyeyi": [
        8780
    ],
    "siyei": [
        8780
    ],
    "sandaohong phula": [
        8792
    ],
    "sandaohong": [
        8792
    ],
    "striped karen": [
        8804
    ],
    "shui yi": [
        8835
    ],
    "shuitian": [
        8835
    ],
    "southern muji": [
        8840
    ],
    "sunum": [
        8850
    ],
    "six yao": [
        8898
    ],
    "six": [
        8898
    ],
    "samatao": [
        8904
    ],
    "samadu": [
        8904
    ],
    "samaduo": [
        8904
    ],
    "samou": [
        8904
    ],
    "sonaga": [
        8905
    ],
    "suoneiga": [
        8905
    ],
    "serbian sign language": [
        8906
    ],
    "szj": [
        8906
    ],
    "slovene sign language": [
        8906
    ],
    "slovenian sign language": [
        8906
    ],
    "slovenski znakovni jezik": [
        8906
    ],
    "srpski znakovni jezik": [
        8906
    ],
    "southeastern lolo yi": [
        8909
    ],
    "southern lolopo": [
        8910
    ],
    "sirenik": [
        8911
    ],
    "sirenik eskimo": [
        8911
    ],
    "sirenik yupik": [
        8911
    ],
    "sirenikski": [
        8911
    ],
    "sanie": [
        8913
    ],
    "sanyie": [
        8913
    ],
    "sa’nguie": [
        8913
    ],
    "shanie": [
        8913
    ],
    "shaniepu": [
        8913
    ],
    "samg phang": [
        8923,
        8924,
        8925,
        8926
    ],
    "samg": [
        8923,
        8924,
        8925,
        8926
    ],
    "shatou": [
        8923,
        8924,
        8925,
        8926
    ],
    "shiqi": [
        8923,
        8924,
        8925,
        8926
    ],
    "suòng phóng": [
        8923,
        8924,
        8925,
        8926
    ],
    "suòng": [
        8923,
        8924,
        8925,
        8926
    ],
    "sym-ket": [
        8928
    ],
    "sugon": [
        8937
    ],
    "southern yukaghir": [
        8940
    ],
    "southern yukagir": [
        8940
    ],
    "shera yogur": [
        8941
    ],
    "shera": [
        8941
    ],
    "shira yughur": [
        8941
    ],
    "sandaun": [
        8962
    ],
    "sierra de juárez zapotec": [
        8969
    ],
    "san juan guelavía zapotec": [
        8970
    ],
    "southern villa alta zapotec": [
        8972
    ],
    "soghaua": [
        8975,
        8976,
        8977
    ],
    "sapoteko": [
        8984,
        9171
    ],
    "san juan yaeé zapotec": [
        8986
    ],
    "santo domingo albarradas zapotec": [
        8987
    ],
    "shingazidja": [
        9005,
        9006
    ],
    "shingazija": [
        9005,
        9006
    ],
    "standard moroccan tamazight": [
        9014
    ],
    "sung": [
        9015
    ],
    "standard chinese": [
        9020,
        9021,
        9022,
        9030,
        9040
    ],
    "shialu": [
        9054
    ],
    "seguha": [
        9057
    ],
    "são paulo kaingáng": [
        9067
    ],
    "songgu zhahua": [
        9068
    ],
    "songgu": [
        9068
    ],
    "shuula": [
        9074
    ],
    "sembilan": [
        9089
    ],
    "sande": [
        9108,
        9109
    ],
    "san miguel chimalapa zoque": [
        9114
    ],
    "santa magdalena zoque": [
        9119
    ],
    "southeastern ixtlán zapotec": [
        9123
    ],
    "san pedro quiatoni zapotec": [
        9125
    ],
    "santa maría quiegolani zapotec": [
        9128
    ],
    "southeastern yautepec zapotec": [
        9130
    ],
    "san juan mixtepec zapoteco": [
        9132
    ],
    "santa inés yatzechi zapotec": [
        9133
    ],
    "southeastern zimatlán zapotec": [
        9133
    ],
    "south central zimatlan zapotec": [
        9135
    ],
    "santiago xanica zapotec": [
        9137
    ],
    "san miguel zapotec": [
        9138
    ],
    "san vicente coatlán zapotec": [
        9139
    ],
    "southern ejutla zapotec": [
        9139
    ],
    "san baltazar loxicha zapotec": [
        9143
    ],
    "san baltázar loxicha zapotec": [
        9143
    ],
    "sápara": [
        9152
    ],
    "sáparo-konambo": [
        9152
    ],
    "sarasira": [
        9155
    ],
    "sirasira": [
        9155
    ],
    "southern rincon zapotec": [
        9158
    ],
    "sukurum": [
        9159
    ],
    "santiago lapaguia zapotec": [
        9162
    ],
    "san agustín mixtepec zapotec": [
        9163
    ],
    "santa catarina albarradas zapotec": [
        9164
    ],
    "së": [
        9166
    ],
    "san dionisio ocotepec zapotec": [
        9169
    ],
    "san raymundo jalpan zapotec": [
        9170
    ],
    "shiza": [
        9171
    ],
    "shiza’": [
        9171
    ],
    "shon": [
        9171
    ],
    "shiwi": [
        9177
    ],
    "shiwi’ma": [
        9177
    ],
    "southern zhuang": [
        9184,
        9188
    ],
    "southern zaza": [
        9186,
        9187
    ]
};
